import * as React from 'react'
import { Walkway } from '../../../Data/Types'

interface WalkwayResultsImageProps {
	projectorNumber: 1 | 2
	walkway: Walkway
}
const viewBoxWidth = 599.71
const WalkwayResultImage: React.FC<WalkwayResultsImageProps> = ({
	walkway,
	projectorNumber,
}) => (
	<svg
		viewBox={`0 0 ${
			projectorNumber === 2 ? viewBoxWidth : viewBoxWidth * 0.6
		} 272.67`}
		id="svg900"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		xmlns="http://www.w3.org/2000/svg"
	>
		<defs id="defs22">
			<clipPath id="clippath">
				<path
					className="cls-12"
					id="polygon4"
					d="m387.27 238.79-71.87-21.51 240.56-15.32 71.42 21.84z"
				/>
			</clipPath>
			<clipPath id="clippath-1">
				<path
					className="cls-12"
					id="polygon7"
					d="m316.78 217.07 70.99 21.66 239.63-14.95-71.05-21.84z"
				/>
			</clipPath>
			<clipPath id="clippath-2">
				<path
					className="cls-12"
					id="polygon10"
					d="m316.78 217.07 70.99 21.66 239.63-14.95-71.05-21.84z"
				/>
			</clipPath>
			<clipPath id="clippath-3">
				<path
					className="cls-12"
					id="polygon13"
					d="m147.5 252.53-74.3-21.68 244.06-13.58 70.53 21.54z"
				/>
			</clipPath>
			<clipPath id="clippath-4">
				<path
					className="cls-12"
					id="polygon16"
					d="m73.62 231.02 73.98 21.81 240.29-14.08-70.99-21.74z"
				/>
			</clipPath>
			<clipPath id="clippath-5">
				<path
					className="cls-12"
					id="polygon19"
					d="m73.62 231.02 73.98 21.81 240.29-14.08-70.99-21.74z"
				/>
			</clipPath>
			<style id="style2">
				{
					'.cls-1{fill:#fff}.cls-3{fill:#bfbfc1}.cls-5{fill:#9f7544}.cls-8{fill:#d58b28}.cls-9{fill:#ffcb05;opacity:.15}.cls-10{stroke:#77787b;stroke-dasharray:0 5;stroke-width:.75px}.cls-10,.cls-11{stroke-miterlimit:10}.cls-10,.cls-11,.cls-12{fill:none}.cls-13{fill:#b89369}.cls-16{fill:#f9a21e}.cls-11{stroke:#231f20;stroke-width:2px}.cls-17{fill:#989899}.cls-18{fill:#e7c59e}.cls-20{fill:#b07d2e}.cls-25{fill:#fff200}.cls-28{fill:#ed1c24}.cls-29{fill:#e29425}.cls-30{fill:#00a651}.cls-34{fill:#9c7145}.cls-37{fill:#231f20}.cls-39{fill:#7d807e}.cls-40{fill:#ba8932}'
				}
			</style>
		</defs>
		<g
			id="g898"
			transform="translate(-46.03)"
			style={{
				isolation: 'isolate',
			}}
		>
			<g id="walkways">
				{projectorNumber === 2 && (
					<g id="_2projectors">
						<g id="bg">
							<g id="LWPOLYLINE">
								<path
									className="cls-3"
									id="polygon24"
									d="m530.2 194.08-240.44 14.98 117.17 35.66 238.81-15.28z"
								/>
							</g>
							<g id="LWPOLYLINE-2">
								<path
									className="cls-17"
									id="polygon27"
									d="m531.39 194.25-240.44 14.97v-89.77l240.44-14.97z"
								/>
							</g>
							<g id="g42">
								<path
									className="cls-9"
									id="polygon30"
									d="M396.88 241.94 448.72 8.63l188.47 220.35z"
								/>
								<g id="g40">
									<g id="g36">
										<path
											className="cls-10"
											id="line32"
											d="M448.43 7.16v208.11"
										/>
										<path
											className="cls-28"
											id="rect34"
											d="M441.5 0h13.87v16H441.5z"
										/>
									</g>
									<path
										className="cls-10"
										id="line38"
										d="m420.06 202.1 28.16 13.17"
									/>
								</g>
							</g>
						</g>
						{walkway === 'AOG058XXX' && (
							<g id="AOG058XXX">
								<path
									className="cls-28"
									id="polygon45"
									d="m301.85 213.23 240.63-15.39 98.21 30.03-240.03 14.93z"
								/>
								<path
									className="cls-25"
									id="polygon47"
									d="m315.4 217.28 240.56-15.32 71.42 21.84-240.11 14.99z"
								/>
								<g
									clipPath="url(#clippath)"
									id="g91"
									style={{
										clipPath: 'url(#clippath)',
									}}
								>
									<g id="g53">
										<path
											className="cls-1"
											id="polygon49"
											d="m508.52 202.42-.18-3.5 188.65 23.07-.03 3.47z"
										/>
										<path
											className="cls-37"
											d="m698.21 225.84-1.25-.15-189.68-23.19-.22-3.98 1.26.15 189.92 23.23-.03 3.93zm-188.44-23.5 185.94 22.73.02-3.01-186.12-22.76z"
											id="path51"
										/>
									</g>
									<g id="g59">
										<path
											className="cls-1"
											id="polygon55"
											d="m377.11 210.81-.34-3.48 187.8 22.91.12 3.44z"
										/>
										<path
											className="cls-37"
											d="m565.94 234.06-1.25-.15-188.82-23.02-.38-3.94 190.31 23.21zm-187.6-23.33 185.09 22.57-.11-2.98-185.28-22.6.29 3.01z"
											id="path57"
										/>
									</g>
									<g id="g65">
										<path
											className="cls-1"
											id="polygon61"
											d="m333.67 213.58-.38-3.46 187.51 22.85.17 3.43z"
										/>
										<path
											className="cls-37"
											d="m522.23 236.78-1.25-.15-188.53-22.97-.44-3.93 190.02 23.16.19 3.89zM334.9 213.51l184.81 22.51-.15-2.97-185-22.54.33 3z"
											id="path63"
										/>
									</g>
									<g id="g71">
										<path
											className="cls-1"
											id="polygon67"
											d="m290.42 216.34-.44-3.45 187.23 22.79.22 3.42z"
										/>
										<path
											className="cls-37"
											d="m478.69 239.48-1.24-.15-188.25-22.91-.5-3.92 189.74 23.1zm-187.05-23.22 184.53 22.46-.19-2.96-184.72-22.49z"
											id="path69"
										/>
									</g>
									<g id="g77">
										<path
											className="cls-1"
											id="polygon73"
											d="m247.34 219.09-.48-3.44 186.94 22.74.27 3.41z"
										/>
										<path
											className="cls-37"
											d="m435.33 242.18-1.24-.15-187.96-22.86-.55-3.9 189.45 23.05zm-186.77-23.16 184.25 22.41-.24-2.96-184.44-22.44.42 2.98z"
											id="path75"
										/>
									</g>
									<g id="g83">
										<path
											className="cls-1"
											id="polygon79"
											d="m420.73 208.03-.29-3.49 188.08 22.96.07 3.45z"
										/>
										<path
											className="cls-37"
											d="m609.85 231.33-1.25-.15-189.1-23.08-.33-3.95 1.26.15 189.34 23.12zm-187.88-23.39 185.37 22.62-.06-2.99-185.56-22.65z"
											id="path81"
										/>
									</g>
									<g id="g89">
										<path
											className="cls-1"
											id="polygon85"
											d="m464.54 205.23-.24-3.5 188.36 23.02.02 3.46z"
										/>
										<path
											className="cls-37"
											d="m653.94 228.6-1.25-.15-189.39-23.13-.27-3.96 1.26.15 189.63 23.17zm-188.16-23.44 185.65 22.68-.02-3-185.84-22.71z"
											id="path87"
										/>
									</g>
								</g>
								<g id="g163">
									<path
										className="cls-1"
										d="m396.21 239.56 4.72-.29 1.37.41-2.8.17 1.12.33 2.4-.15 1.29.39-2.4.15 2.61.78-1.92.12z"
										id="path93"
									/>
									<path
										className="cls-1"
										d="M404.93 240.17c-1.04-.31-1.57-.57-1.59-.78-.02-.21.47-.35 1.48-.41s2.11-.03 3.24.11c1.13.14 2.21.36 3.23.67.75.22 1.24.41 1.47.57.23.16.25.29.06.4-.19.11-.64.18-1.32.23-.7.04-1.39.05-2.08 0a20.747 20.747 0 0 1-4.49-.79zm1.92-.12c.64.19 1.22.32 1.74.39.51.07.97.09 1.37.07.4-.02.59-.09.54-.18-.05-.1-.43-.25-1.15-.47-.6-.18-1.16-.3-1.67-.37a7.43 7.43 0 0 0-1.37-.07c-.39.02-.55.09-.51.18.05.1.4.25 1.05.44z"
										id="path95"
									/>
									<path
										className="cls-1"
										d="m415.58 240.66-6.39-1.91 3.19-.2c.59-.04 1.1-.05 1.51-.04.42.01.86.05 1.34.13.47.07.92.17 1.32.29.35.11.59.2.7.29.11.09.12.16.02.23-.06.04-.2.08-.42.12.31 0 .55.02.73.04.12.01.34.04.64.08.31.04.53.08.67.1l2.78.5-2.16.13-2.97-.52c-.38-.07-.66-.11-.84-.13-.24-.02-.44-.03-.62-.02h-.17l2.59.79zm-1.88-1.26.81-.05c.09 0 .23-.02.42-.06.1-.02.14-.04.11-.08-.03-.04-.11-.08-.25-.12-.21-.06-.43-.11-.67-.13-.24-.03-.53-.03-.88 0l-.84.05z"
										id="path97"
									/>
									<path
										className="cls-1"
										d="m415.9 238.33 1.91-.12 2.41.72-.41-.85 2.55-.16.15.86 6.34 1.05-2.36.15-3.93-.71.08.38 1.56.47-1.91.12-6.39-1.92z"
										id="path99"
									/>
									<path
										className="cls-1"
										d="m423.1 237.88 1.91-.12 4.81 1.44 2.99-.19 1.57.47-4.9.31-6.39-1.92z"
										id="path101"
									/>
									<path
										className="cls-1"
										d="m428.95 237.52 1.92-.12 6.38 1.92-1.92.12z"
										id="path103"
									/>
									<path
										className="cls-1"
										d="m432.26 237.31 4.74-.3 1.37.41-2.81.18 1.11.33 2.4-.15 1.29.39-2.4.15 2.61.78-1.93.12-6.38-1.92z"
										id="path105"
									/>
									<path
										className="cls-1"
										d="m437.59 236.98 5.83-.36 1.58.47-1.96.12 4.81 1.44-1.92.12-4.81-1.44-1.96.12-1.58-.47z"
										id="path107"
									/>
									<path
										className="cls-1"
										d="m446.75 236.41 5.84-.36 1.58.47-1.96.12 4.8 1.45-1.92.12-4.8-1.45-1.96.12z"
										id="path109"
									/>
									<path
										className="cls-1"
										d="m459.86 237.91-6.38-1.92 3.2-.2c.59-.04 1.1-.05 1.52-.04.42.01.87.05 1.34.13.48.07.92.17 1.32.29.35.11.59.2.7.29.11.09.12.16.02.23-.06.04-.2.08-.42.12.31 0 .55.02.74.04.12.01.34.04.64.08.31.04.53.08.67.1l2.78.5-2.17.14-2.98-.52c-.38-.07-.66-.11-.84-.13-.24-.02-.44-.03-.62-.02h-.17l2.59.79-1.93.12zm-1.86-1.26.81-.05c.09 0 .23-.02.42-.06.1-.02.14-.04.11-.08-.03-.04-.11-.08-.25-.12-.21-.06-.43-.11-.67-.13-.24-.03-.53-.03-.88 0l-.84.05z"
										id="path111"
									/>
									<path
										className="cls-1"
										d="m469.36 236.93-2.18.14.75.34-1.96.12-4.04-2.07 2.1-.13 8.72 1.78-2.01.13-1.36-.3zm-1.78-.39-2.98-.65 1.61.73 1.37-.09z"
										id="path113"
									/>
									<path
										className="cls-1"
										d="m466.98 235.14 4.76-.3 1.37.41-2.82.18 1.11.34 2.41-.15 1.29.39-2.41.15 2.61.79-1.93.12-6.38-1.92z"
										id="path115"
									/>
									<path
										className="cls-1"
										d="m472.78 234.78 4.76-.3 1.37.41-2.83.18 1.11.34 2.41-.15 1.29.39-2.41.15 2.6.79-1.93.12-6.38-1.92z"
										id="path117"
									/>
									<path
										className="cls-1"
										d="m478.65 234.42 1.93-.12 6.38 1.92-1.93.12z"
										id="path119"
									/>
									<path
										className="cls-1"
										d="m489.88 235.09 2.21.05c.37.15.6.29.68.4.08.11.02.21-.17.28-.2.07-.57.13-1.13.16-.68.04-1.33.05-1.96.01-.63-.03-1.36-.12-2.17-.25-.82-.13-1.62-.32-2.41-.56-1.06-.32-1.59-.58-1.61-.79-.02-.21.47-.34 1.48-.4.79-.05 1.57-.04 2.34.03.77.07 1.61.2 2.5.39l-1.31.22-.61-.12a6.94 6.94 0 0 0-.74-.08c-.24-.01-.45-.02-.65 0-.44.03-.59.1-.46.23.09.09.42.22.99.4.71.21 1.3.35 1.77.42s.9.09 1.28.06c.37-.02.54-.07.52-.15-.02-.08-.19-.18-.51-.3z"
										id="path121"
									/>
									<path
										className="cls-1"
										d="m494.56 234.65 2.52-.16 1.37.41-2.52.16z"
										id="path123"
									/>
									<path
										className="cls-1"
										d="m497.48 233.24 2.87-.18c.56-.04 1.1-.04 1.6-.01s1.02.08 1.54.15c.52.07 1.03.17 1.52.28.49.11.95.23 1.39.36.68.21 1.13.37 1.36.49.22.12.33.23.31.32-.02.09-.14.16-.36.21-.31.06-.63.1-.98.12l-2.87.18-6.37-1.93zm3.37.32 3.48 1.05.47-.03c.4-.03.64-.06.72-.09.08-.03.05-.09-.08-.17-.13-.08-.45-.19-.96-.34-.68-.2-1.25-.34-1.71-.4-.46-.06-.95-.08-1.45-.05l-.48.03z"
										id="path125"
									/>
									<path
										className="cls-1"
										d="m513.02 234.21-2.19.14.75.34-1.97.12-4.02-2.07 2.11-.13 8.72 1.78-2.02.13-1.36-.3zm-1.78-.39-2.98-.65 1.61.74z"
										id="path127"
									/>
									<path
										className="cls-1"
										d="m510.67 232.42 1.8-.11 5.88.92-3.53-1.07 1.82-.11 6.37 1.93-1.82.11-5.84-.91 3.5 1.06-1.82.11-6.37-1.93z"
										id="path129"
									/>
									<path
										className="cls-1"
										d="m525.14 233-1.32-.4 2.99-.19 2.71.82c-.18.16-.41.27-.71.34s-.75.12-1.35.16c-.74.05-1.48.04-2.2 0-.73-.05-1.47-.14-2.24-.28-.77-.14-1.48-.31-2.14-.51-.7-.21-1.16-.4-1.39-.58-.23-.17-.21-.32.07-.43.22-.09.69-.16 1.4-.2.71-.04 1.27-.06 1.74-.04.47.02.95.06 1.45.13.49.07 1 .16 1.53.28l-1.53.22c-.32-.07-.63-.12-.94-.14-.31-.03-.61-.03-.89-.01-.42.03-.61.09-.56.2.05.11.4.26 1.05.45.69.21 1.31.35 1.86.42s1.05.1 1.51.07c.22-.01.39-.04.52-.07.13-.03.25-.08.35-.14l-.6-.18-1.29.08z"
										id="path131"
									/>
									<path
										className="cls-1"
										d="m525.2 231.51 5.18-.32 1.36.41-3.25.2 1.01.31 3.01-.19 1.3.39-3.01.19 1.26.38 3.34-.21 1.44.44-5.28.33-6.37-1.93z"
										id="path133"
									/>
									<path
										className="cls-1"
										d="m537.92 233.05-6.37-1.93 3.23-.2c.6-.04 1.11-.05 1.53-.04.42.01.87.05 1.34.13.48.07.92.17 1.32.29.35.11.58.2.69.29.11.09.11.16.01.23-.06.04-.21.08-.43.12.31 0 .56.02.74.04.12.01.34.04.64.08.31.04.53.08.67.1l2.78.5-2.19.14-2.98-.53c-.38-.07-.66-.11-.84-.13-.24-.02-.45-.03-.62-.02h-.17l2.58.79-1.94.12zm-1.84-1.27.82-.05c.09 0 .23-.02.43-.06.1-.02.14-.04.11-.08-.03-.04-.11-.08-.25-.12-.21-.06-.43-.11-.67-.13-.24-.03-.53-.03-.89 0l-.85.05 1.29.39z"
										id="path135"
									/>
									<path
										className="cls-1"
										d="m540.81 230.54 5.89-.37 1.57.48-1.98.12 4.79 1.45-1.94.12-4.79-1.45-1.98.12-1.57-.48z"
										id="path137"
									/>
									<path
										className="cls-1"
										d="M550.22 231.12c-1.04-.32-1.56-.58-1.57-.79 0-.21.5-.35 1.51-.41 1.04-.07 2.13-.03 3.27.11 1.13.14 2.21.36 3.24.67.74.23 1.23.42 1.46.58.23.16.24.29.04.4-.2.11-.65.19-1.35.23-.71.04-1.41.05-2.1 0-.69-.04-1.43-.13-2.21-.26s-1.55-.31-2.29-.54zm1.95-.12c.64.2 1.22.33 1.74.4s.98.09 1.38.07c.42-.03.6-.09.55-.19-.05-.1-.43-.25-1.14-.47-.6-.18-1.16-.31-1.67-.38-.52-.07-.98-.09-1.38-.07-.4.02-.56.09-.52.19.04.1.39.25 1.04.45z"
										id="path139"
									/>
									<path
										className="cls-1"
										d="m557.49 229.5 3.22-.2c.7-.04 1.4-.03 2.09.06.69.08 1.35.22 1.97.41.64.2.95.36.93.49-.02.13-.42.22-1.2.27l-1.06.07 2.36.72-1.95.12-6.36-1.93zm4.66.7.48-.03c.37-.02.57-.06.59-.11.02-.05-.07-.11-.28-.17a4.12 4.12 0 0 0-.7-.14c-.27-.03-.59-.04-.95-.02l-.55.03 1.42.43z"
										id="path141"
									/>
									<path
										className="cls-1"
										d="m563.83 229.1 5.2-.32 1.36.41-3.26.2 1.01.31 3.02-.19 1.3.39-3.02.19 1.25.38 3.35-.21 1.44.44-5.3.33-6.36-1.93z"
										id="path143"
									/>
									<path
										className="cls-1"
										d="m570.2 228.71 2.89-.18c.57-.04 1.11-.04 1.61-.01.51.03 1.02.08 1.54.15.52.07 1.03.17 1.52.28.49.11.95.23 1.39.37.68.21 1.13.37 1.35.5.22.12.32.23.3.33-.02.09-.14.16-.37.21-.31.06-.64.1-.98.12l-2.89.18-6.36-1.93zm3.38.32 3.48 1.06.48-.03c.41-.03.65-.06.73-.1.08-.04.06-.1-.07-.17s-.45-.19-.96-.35c-.67-.21-1.24-.34-1.71-.4s-.95-.08-1.45-.05l-.48.03z"
										id="path145"
									/>
									<path
										className="cls-1"
										d="m577 228.28 5.21-.32 1.36.41-3.26.2 1.01.31 3.03-.19 1.3.39-3.03.19 1.25.38 3.36-.21 1.44.44-5.3.33-6.36-1.94z"
										id="path147"
									/>
									<path
										className="cls-1"
										d="m587.27 229.2 1.73-.15c.34.09.66.16.94.2.46.07.87.09 1.24.06.28-.02.43-.05.44-.1.01-.05-.06-.1-.23-.15-.16-.05-.38-.09-.66-.12-.27-.03-.73-.05-1.37-.05-1.05 0-1.91-.05-2.6-.12-.69-.08-1.28-.19-1.78-.34-.33-.1-.54-.2-.65-.3-.11-.1-.05-.19.16-.26.21-.07.64-.13 1.3-.17.8-.05 1.57-.04 2.29.02.72.07 1.46.2 2.2.39l-1.73.15c-.33-.08-.65-.14-.93-.17a4.76 4.76 0 0 0-.84-.02c-.23.01-.35.04-.37.08-.02.04.04.08.18.12.1.03.24.06.41.07.18.02.47.03.89.03 1.04 0 1.83.02 2.39.06.56.03 1.06.09 1.51.16.45.07.85.17 1.19.27.41.12.67.25.79.36.12.12.07.22-.15.3-.22.08-.64.14-1.25.18-1.07.07-2.02.05-2.85-.05-.83-.1-1.59-.25-2.29-.44z"
										id="path149"
									/>
									<path
										className="cls-1"
										d="m589.26 227.52 5.92-.37 1.57.48-1.99.12 4.79 1.46-1.95.12-4.79-1.46-1.98.12-1.57-.48z"
										id="path151"
									/>
									<path
										className="cls-1"
										d="m602.44 229.03-6.36-1.94 3.25-.2c.6-.04 1.11-.05 1.54-.04.42.01.87.05 1.35.13.48.07.92.17 1.32.3.35.11.58.2.69.29.11.09.11.16 0 .23-.06.04-.21.08-.43.12.31 0 .56.02.74.04.12.01.34.04.65.08s.53.08.67.1l2.78.5-2.2.14-2.98-.53c-.38-.07-.66-.11-.84-.13-.24-.02-.45-.03-.62-.02h-.17l2.58.8-1.96.12zm-1.82-1.27.82-.05c.09 0 .23-.03.43-.06.1-.02.14-.04.12-.08-.03-.04-.11-.08-.25-.12-.21-.06-.43-.11-.67-.13-.24-.03-.54-.03-.89 0l-.86.05 1.29.39z"
										id="path153"
									/>
									<path
										className="cls-1"
										d="m602.99 226.66 1.95-.12 6.36 1.94-1.95.12z"
										id="path155"
									/>
									<path
										className="cls-1"
										d="m615.52 227.83-2.21.14.74.34-1.99.12-3.98-2.09 2.13-.13 8.73 1.79-2.04.13-1.36-.3zm-1.78-.39-2.98-.65 1.6.74 1.39-.09z"
										id="path157"
									/>
									<path
										className="cls-1"
										d="m613.21 226.02 1.82-.11 5.89.93-3.52-1.07 1.84-.11 6.35 1.94-1.84.11-5.85-.92 3.49 1.06-1.83.11z"
										id="path159"
									/>
									<path
										className="cls-1"
										d="m624.45 226.89 1.74-.15c.34.09.66.16.94.2.46.07.87.09 1.25.06.28-.02.43-.05.45-.1.02-.05-.06-.1-.23-.15-.16-.05-.38-.09-.66-.12-.27-.03-.73-.05-1.37-.05-1.05 0-1.92-.05-2.6-.12-.69-.08-1.28-.19-1.78-.34-.33-.1-.54-.2-.64-.3-.1-.1-.05-.19.16-.26.21-.07.65-.13 1.3-.17.81-.05 1.57-.04 2.3.02.73.07 1.46.2 2.2.39l-1.73.15c-.33-.08-.65-.14-.93-.17a4.76 4.76 0 0 0-.84-.02c-.23.01-.35.04-.37.08-.02.04.04.08.18.12.1.03.24.06.42.07.18.02.47.03.89.03 1.04 0 1.84.02 2.4.06.56.03 1.06.09 1.51.16.45.08.85.17 1.19.27.41.12.67.25.79.37s.07.22-.16.3c-.22.08-.64.14-1.26.18-1.07.07-2.03.05-2.85-.05-.83-.1-1.59-.25-2.29-.44z"
										id="path161"
									/>
								</g>
								<g id="g235">
									<path
										className="cls-1"
										d="m546.86 201.18-4.84.31-1.38-.42 2.87-.18-1.12-.34-2.45.16-1.3-.4 2.45-.16-2.63-.8 1.97-.13 6.43 1.97z"
										id="path165"
									/>
									<path
										className="cls-1"
										d="M538 200.56c1.05.32 1.58.59 1.59.8 0 .22-.5.36-1.53.42s-2.15.03-3.3-.11c-1.14-.14-2.23-.37-3.27-.68-.75-.23-1.24-.43-1.48-.59-.23-.16-.25-.3-.05-.41.2-.11.65-.19 1.36-.24a15 15 0 0 1 2.12 0c.7.04 1.44.13 2.24.26.79.13 1.56.32 2.31.55zm-1.96.12c-.65-.2-1.23-.33-1.76-.4-.52-.07-.99-.09-1.39-.07-.4.02-.61.09-.56.19.05.1.43.26 1.15.48.61.18 1.17.31 1.69.38s.99.09 1.4.07c.39-.03.57-.09.52-.19-.04-.1-.39-.25-1.05-.45z"
										id="path167"
									/>
									<path
										className="cls-1"
										d="m527.15 200.06 6.43 1.96-3.26.21c-.6.04-1.12.05-1.54.04-.42-.01-.88-.05-1.36-.13-.48-.07-.93-.17-1.34-.3-.36-.11-.59-.21-.7-.3-.11-.09-.11-.17-.01-.23.06-.04.21-.08.43-.12-.31 0-.56-.02-.75-.04-.12-.01-.34-.04-.65-.08s-.53-.08-.67-.1l-2.81-.51 2.21-.14 3.01.53c.39.07.67.11.85.13.24.02.45.03.63.02h.17l-2.61-.81 1.96-.13zm1.87 1.29-.82.05c-.09 0-.23.03-.43.06-.1.02-.14.04-.12.08.03.04.11.08.25.12.21.06.43.11.67.13.24.03.54.03.9 0l.86-.05-1.31-.4z"
										id="path169"
									/>
									<path
										className="cls-1"
										d="m526.73 202.47-1.95.12-2.43-.74.39.87-2.6.17-.12-.89-6.42-1.07 2.4-.15 3.98.72-.07-.39-1.57-.48 1.95-.12z"
										id="path171"
									/>
									<path
										className="cls-1"
										d="m519.39 202.93-1.95.12-4.85-1.48-3.04.19-1.59-.48 5-.32 6.44 1.96z"
										id="path173"
									/>
									<path
										className="cls-1"
										d="m513.43 203.31-1.95.12-6.44-1.96 1.95-.12z"
										id="path175"
									/>
									<path
										className="cls-1"
										d="m510.07 203.53-4.82.31-1.38-.42 2.86-.18-1.12-.34-2.44.16-1.3-.4 2.44-.16-2.63-.8 1.96-.13 6.44 1.96z"
										id="path177"
									/>
									<path
										className="cls-1"
										d="m504.64 203.87-5.92.38-1.59-.48 1.99-.13-4.85-1.48 1.95-.12 4.85 1.48 1.99-.13 1.59.48z"
										id="path179"
									/>
									<path
										className="cls-1"
										d="m495.34 204.47-5.92.38-1.59-.48 1.98-.13-4.85-1.48 1.95-.12 4.85 1.48 1.99-.13z"
										id="path181"
									/>
									<path
										className="cls-1"
										d="m482.08 202.94 6.44 1.96-3.24.21c-.6.04-1.11.05-1.54.04a9.59 9.59 0 0 1-1.35-.13c-.48-.07-.93-.17-1.34-.3-.36-.11-.59-.21-.7-.3-.11-.09-.12-.17-.02-.23.06-.04.21-.08.43-.12-.31 0-.56-.02-.74-.04-.12-.01-.34-.04-.65-.08s-.53-.08-.67-.1l-2.81-.51 2.2-.14 3.01.53c.39.07.67.11.85.13.24.02.45.03.63.02h.17l-2.62-.81 1.95-.12zm1.88 1.29-.82.05c-.09 0-.23.03-.43.06-.1.02-.14.04-.11.08.03.04.11.08.25.12.21.06.43.11.67.13.24.03.54.03.89 0l.85-.05-1.31-.4z"
										id="path183"
									/>
									<path
										className="cls-1"
										d="m472.46 203.95 2.21-.14-.76-.34 1.99-.13 4.08 2.11-2.12.14-8.81-1.81 2.04-.13 1.38.3zm1.8.4 3.01.66-1.63-.75z"
										id="path185"
									/>
									<path
										className="cls-1"
										d="m474.86 205.77-4.8.31-1.38-.42 2.85-.18-1.13-.34-2.44.16-1.3-.39 2.44-.16-2.63-.8 1.95-.12 6.44 1.96z"
										id="path187"
									/>
									<path
										className="cls-1"
										d="m469.01 206.15-4.8.31-1.38-.42 2.85-.18-1.13-.34-2.43.16-1.3-.39 2.43-.16-2.63-.8 1.95-.12 6.45 1.96z"
										id="path189"
									/>
									<path
										className="cls-1"
										d="m463.08 206.52-1.95.12-6.45-1.96 1.95-.12z"
										id="path191"
									/>
									<path
										className="cls-1"
										d="m451.76 205.85-2.23-.05c-.38-.16-.6-.29-.69-.41-.08-.12-.03-.21.17-.28.2-.07.58-.13 1.14-.16.68-.04 1.34-.05 1.98-.01.64.03 1.37.12 2.19.25.83.14 1.64.32 2.44.57 1.07.32 1.61.59 1.63.8.02.21-.48.35-1.49.41-.79.05-1.58.04-2.36-.03-.78-.07-1.62-.2-2.52-.39l1.32-.23c.26.06.46.1.62.12.26.04.51.07.75.08.24.01.46.02.65 0 .44-.03.59-.1.47-.23-.09-.09-.43-.23-1-.4-.71-.22-1.31-.36-1.79-.43s-.91-.09-1.29-.06-.54.07-.52.15c.02.08.2.18.52.31z"
										id="path193"
									/>
									<path
										className="cls-1"
										d="m447.05 206.3-2.53.16-1.39-.42 2.53-.16z"
										id="path195"
									/>
									<path
										className="cls-1"
										d="m444.14 207.73-2.88.18c-.57.04-1.1.04-1.61.02-.51-.03-1.02-.08-1.55-.15-.52-.08-1.03-.17-1.53-.28-.5-.11-.96-.24-1.4-.37-.69-.21-1.15-.38-1.37-.5-.23-.12-.33-.23-.32-.33.01-.1.13-.17.36-.21.31-.06.63-.11.98-.13l2.88-.18 6.45 1.95zm-3.4-.32-3.52-1.07-.47.03c-.4.03-.65.06-.73.1-.08.04-.05.1.08.17s.46.19.97.35c.68.21 1.26.34 1.73.4s.95.08 1.46.05z"
										id="path197"
									/>
									<path
										className="cls-1"
										d="m428.49 206.76 2.2-.14-.76-.34 1.98-.13 4.1 2.1-2.11.13-8.8-1.8 2.03-.13 1.38.3zm1.8.4 3.01.66-1.63-.75z"
										id="path199"
									/>
									<path
										className="cls-1"
										d="m430.91 208.58-1.81.12-5.93-.93 3.57 1.08-1.82.12-6.45-1.95 1.82-.12 5.89.92-3.54-1.07 1.82-.12z"
										id="path201"
									/>
									<path
										className="cls-1"
										d="m416.38 208 1.34.41-2.99.19-2.75-.83c.17-.16.4-.27.7-.35.29-.07.74-.13 1.35-.17.74-.05 1.48-.05 2.21 0a20.792 20.792 0 0 1 4.42.79c.7.21 1.18.41 1.41.58.24.18.22.32-.05.44-.22.09-.68.16-1.4.2-.69.04-1.27.06-1.74.04-.47-.02-.96-.06-1.45-.13-.5-.07-1.01-.16-1.54-.28l1.52-.22c.32.07.64.12.95.14.31.03.61.03.9.01.42-.03.61-.09.56-.2-.05-.11-.41-.26-1.06-.46-.7-.21-1.32-.35-1.88-.43-.55-.07-1.06-.1-1.51-.07-.22.01-.39.04-.52.07-.13.03-.25.08-.34.14l.61.18 1.29-.08z"
										id="path203"
									/>
									<path
										className="cls-1"
										d="m416.36 209.5-5.18.33-1.38-.42 3.24-.21-1.03-.31-3.01.19-1.32-.4 3.01-.19-1.27-.38-3.33.21-1.46-.44 5.27-.34 6.45 1.95z"
										id="path205"
									/>
									<path
										className="cls-1"
										d="m403.57 207.96 6.45 1.95-3.22.21c-.6.04-1.11.05-1.53.04a9.59 9.59 0 0 1-1.35-.13 8.78 8.78 0 0 1-1.34-.3c-.36-.11-.59-.21-.71-.29-.11-.09-.12-.16-.02-.23.06-.04.2-.08.42-.12-.31 0-.56-.02-.74-.04-.12-.01-.34-.04-.65-.08s-.53-.08-.67-.1l-2.81-.51 2.18-.14 3.01.53c.39.07.67.11.85.13.24.02.45.03.62.02h.17l-2.62-.8 1.94-.12zm1.9 1.28-.81.05c-.09 0-.23.03-.42.06-.1.02-.14.04-.11.08.03.04.11.08.25.12.21.06.43.11.67.13.24.03.54.03.89 0l.85-.05-1.31-.4z"
										id="path207"
									/>
									<path
										className="cls-1"
										d="m400.79 210.5-5.86.37-1.59-.48 1.97-.13-4.86-1.47 1.93-.12 4.86 1.47 1.97-.13 1.59.48z"
										id="path209"
									/>
									<path
										className="cls-1"
										d="M391.37 209.92c1.05.32 1.59.58 1.61.8.02.22-.48.35-1.49.42s-2.13.03-3.26-.11c-1.14-.14-2.23-.36-3.27-.68-.76-.23-1.25-.42-1.49-.58-.24-.16-.26-.3-.06-.41.19-.11.64-.19 1.33-.23.69-.04 1.4-.05 2.09 0 .69.04 1.43.13 2.22.26.79.13 1.56.31 2.32.54zm-1.94.12c-.65-.2-1.24-.33-1.76-.4s-.98-.09-1.38-.07c-.4.02-.6.09-.54.19.05.1.44.26 1.16.47.61.18 1.17.31 1.69.38s.98.09 1.38.07c.4-.02.56-.09.51-.19-.05-.1-.4-.25-1.06-.45z"
										id="path211"
									/>
									<path
										className="cls-1"
										d="m384.2 211.55-3.2.2c-.7.04-1.39.03-2.08-.06a11.7 11.7 0 0 1-1.99-.41c-.65-.2-.97-.36-.96-.5.01-.14.4-.23 1.18-.28l1.05-.07-2.4-.72 1.93-.12 6.46 1.95zm-4.69-.71-.47.03c-.37.02-.57.06-.58.11-.02.05.08.11.29.17.21.06.44.11.71.14.27.03.59.04.95.02l.55-.03-1.44-.43z"
										id="path213"
									/>
									<path
										className="cls-1"
										d="m377.91 211.95-5.16.33-1.38-.41 3.23-.21-1.03-.31-3 .19-1.32-.4 3-.19-1.27-.38-3.32.21-1.46-.44 5.25-.34 6.46 1.94z"
										id="path215"
									/>
									<path
										className="cls-1"
										d="m371.6 212.36-2.86.18c-.56.04-1.1.04-1.6.02a18.785 18.785 0 0 1-3.07-.43c-.5-.11-.96-.23-1.4-.37-.69-.21-1.15-.37-1.38-.5-.23-.12-.34-.23-.33-.33.01-.09.13-.16.35-.21.3-.06.63-.1.97-.13l2.86-.18 6.46 1.94zm-3.39-.32-3.53-1.06-.47.03c-.4.03-.64.06-.72.1-.08.04-.05.1.09.17.13.08.46.19.98.35.68.21 1.26.34 1.73.4s.95.08 1.45.05l.48-.03z"
										id="path217"
									/>
									<path
										className="cls-1"
										d="m364.86 212.79-5.15.33-1.38-.41 3.22-.21-1.03-.31-2.99.19-1.32-.4 2.99-.19-1.27-.38-3.32.21-1.46-.44 5.25-.34 6.46 1.94z"
										id="path219"
									/>
									<path
										className="cls-1"
										d="m354.6 211.87-1.71.15c-.35-.09-.66-.16-.95-.2-.46-.07-.87-.09-1.24-.06-.27.02-.42.05-.43.1-.01.05.07.1.24.15.17.05.39.09.66.12s.73.05 1.36.05c1.04 0 1.9.05 2.59.12.69.07 1.28.19 1.79.34.33.1.55.2.66.3.11.1.06.19-.14.26s-.63.13-1.28.17c-.79.05-1.55.04-2.28-.02a13.5 13.5 0 0 1-2.21-.39l1.7-.15c.34.08.65.14.94.17.29.03.57.04.84.02.22-.01.34-.04.36-.08.01-.04-.05-.08-.19-.12-.1-.03-.24-.06-.42-.07a8.94 8.94 0 0 0-.88-.03c-1.03 0-1.82-.02-2.38-.06-.56-.03-1.06-.09-1.51-.16-.45-.08-.85-.17-1.2-.27-.41-.12-.69-.25-.82-.37s-.09-.22.13-.3c.22-.08.62-.14 1.23-.18 1.06-.07 2-.05 2.83.05.83.1 1.6.25 2.31.44z"
										id="path221"
									/>
									<path
										className="cls-1"
										d="m352.75 213.56-5.84.37-1.6-.48 1.96-.12-4.87-1.46 1.92-.12 4.87 1.46 1.96-.12 1.6.48z"
										id="path223"
									/>
									<path
										className="cls-1"
										d="m339.56 212.05 6.46 1.94-3.2.2c-.59.04-1.1.05-1.52.04a9.59 9.59 0 0 1-1.35-.13 8.78 8.78 0 0 1-1.34-.3c-.36-.11-.59-.21-.71-.29-.11-.09-.12-.16-.03-.23.06-.04.2-.08.42-.12-.31 0-.55-.02-.74-.04-.12-.01-.34-.04-.65-.08s-.53-.08-.67-.1l-2.8-.5 2.17-.14 3 .53c.39.07.67.11.85.13.24.02.44.03.62.02h.17l-2.62-.8 1.93-.12zm1.92 1.28-.81.05c-.09 0-.23.03-.42.06-.1.02-.14.04-.11.08.03.04.11.08.25.12.21.06.43.11.67.13.24.03.53.03.88 0l.84-.05-1.31-.39z"
										id="path225"
									/>
									<path
										className="cls-1"
										d="m339.22 214.42-1.92.12-6.47-1.94 1.92-.12z"
										id="path227"
									/>
									<path
										className="cls-1"
										d="m326.71 213.26 2.18-.14-.77-.34 1.96-.13 4.13 2.09-2.09.13-8.8-1.79 2.01-.13 1.38.3zm1.8.39 3.01.65-1.65-.74z"
										id="path229"
									/>
									<path
										className="cls-1"
										d="m329.17 215.06-1.79.11-5.91-.92 3.58 1.07-1.81.12-6.47-1.94 1.81-.12 5.87.92-3.55-1.06 1.8-.12z"
										id="path231"
									/>
									<path
										className="cls-1"
										d="m317.98 214.2-1.7.15c-.35-.09-.66-.16-.95-.2-.46-.07-.87-.09-1.24-.06-.27.02-.42.05-.43.1-.01.05.07.1.24.15.17.05.39.09.66.12s.73.05 1.36.05c1.04 0 1.9.05 2.58.12.69.07 1.28.19 1.79.34.33.1.55.2.67.3.11.1.07.19-.14.26-.2.07-.62.13-1.27.17-.79.05-1.55.04-2.27-.02-.72-.07-1.46-.2-2.21-.39l1.69-.15c.34.08.65.14.94.17.29.03.56.04.83.02.22-.01.34-.04.36-.08.01-.04-.05-.08-.19-.12-.1-.03-.24-.06-.42-.07a8.94 8.94 0 0 0-.88-.03c-1.03 0-1.81-.02-2.37-.06-.55-.03-1.06-.09-1.51-.16-.45-.07-.85-.17-1.2-.27-.42-.12-.69-.25-.82-.36-.13-.12-.09-.22.12-.3.21-.08.62-.14 1.22-.18 1.05-.07 2-.05 2.82.05.83.1 1.6.25 2.3.44z"
										id="path233"
									/>
								</g>
							</g>
						)}
						{walkway === 'AOG059XXX' && (
							<g id="AOG059XXX">
								<path
									className="cls-1"
									id="polygon238"
									d="m303.86 213.18 238.62-15.34 98.21 30.03-239.85 14.92z"
								/>
								<path
									className="cls-30"
									id="polygon240"
									d="m312.24 215.74 238.74-15.3 81.22 24.83-239.74 14.96z"
								/>
								<path
									className="cls-25"
									id="polygon242"
									d="m304.34 213.32 238.63-15.33 9.83 3.01-238.76 15.29z"
								/>
								<path
									className="cls-25"
									id="polygon244"
									d="m390.66 239.68 239.72-14.96 9.82 3-239.84 14.92z"
								/>
								<path
									className="cls-1"
									id="polygon246"
									d="M314.04 216.29 552.8 201l.49.15-238.76 15.29z"
								/>
								<path
									className="cls-1"
									id="polygon248"
									d="m390.42 239.61 239.72-14.97.49.15-239.73 14.97z"
								/>
							</g>
						)}
						{walkway === 'AOG061XXX' && (
							<g id="AOG061XXX">
								<path
									className="cls-1"
									id="polygon251"
									d="m412.2 206.18 19.12-1.23 98.23 29.83-19.09 1.19z"
								/>
								<path
									className="cls-25"
									id="polygon253"
									d="m392.19 207.45 19.1-1.22 98.26 29.8-19.06 1.18z"
								/>
								<path
									className="cls-25"
									id="polygon255"
									d="m432.23 204.9 19.17-1.23 98.19 29.87-19.13 1.19z"
								/>
								<path
									className="cls-1"
									id="polygon257"
									d="m452.31 203.61 19.2-1.22 98.16 29.9-19.17 1.19z"
								/>
								<path
									className="cls-1"
									id="polygon259"
									d="m372.23 208.73 19.06-1.22 98.3 29.76-19.02 1.18z"
								/>
								<path
									className="cls-25"
									id="polygon261"
									d="m352.31 210 19.01-1.21 98.34 29.72-18.99 1.18z"
								/>
								<path
									className="cls-25"
									id="polygon263"
									d="m472.42 202.33 19.24-1.23 98.12 29.94-19.2 1.19z"
								/>
								<path
									className="cls-1"
									id="polygon265"
									d="m302.2 213.2 9.46-.6 98.44 29.61-9.44.59z"
								/>
								<path
									className="cls-1"
									id="polygon267"
									d="m532.99 198.46 9.67-.62 98.03 30.03-9.65.6z"
								/>
								<path
									className="cls-1"
									id="polygon269"
									d="m492.58 201.04 19.27-1.23 98.08 29.97-19.23 1.2z"
								/>
								<path
									className="cls-1"
									id="polygon271"
									d="m332.42 211.27 18.98-1.21 98.37 29.69-18.95 1.17z"
								/>
								<path
									className="cls-25"
									id="polygon273"
									d="m512.77 199.75 19.3-1.23 98.05 30.01-19.27 1.2z"
								/>
								<path
									className="cls-25"
									id="polygon275"
									d="m312.57 212.54 18.94-1.21 98.41 29.65-18.92 1.18z"
								/>
							</g>
						)}
						{walkway === 'AOG131XXX' && (
							<g id="AOG131XXX">
								<path
									className="cls-1"
									id="polygon278"
									d="m304.39 213.29 239.55-15.16 13.36 4.1-239.57 15.13z"
								/>
								<path
									className="cls-1"
									id="polygon280"
									d="m386.78 238.42 239.63-14.94 13.29 4.08-239.64 14.91z"
								/>
								<path
									className="cls-25"
									id="polygon282"
									d="M303.44 213 543 197.84l13.35 4.1-239.57 15.13z"
								/>
								<path
									className="cls-25"
									id="polygon284"
									d="m387.77 238.73 239.63-14.95 13.29 4.09-239.64 14.91z"
								/>
								<path
									className="cls-12"
									id="polygon286"
									d="m316.78 217.07 239.57-15.13 71.05 21.84-239.63 14.95z"
								/>
								<g
									clipPath="url(#clippath-1)"
									id="g324"
									style={{
										clipPath: 'url(#clippath-1)',
									}}
								>
									<g id="g322">
										<path
											className="cls-1"
											id="polygon288"
											d="m325.53 216.52-3.36.21 140.37 17.33 3.37-.21 21.66-1.35 3.38-.21-140.49-17.34-3.37.21z"
										/>
										<path
											className="cls-1"
											id="polygon290"
											d="m368.8 213.79-3.37.21 140.56 17.35 3.38-.21 21.72-1.35 3.39-.21-140.68-17.37-3.38.21z"
										/>
										<path
											className="cls-1"
											id="polygon292"
											d="m412.24 211.05-3.38.21 140.75 17.37 3.4-.21 21.77-1.36 3.4-.21-140.88-17.39-3.38.22z"
										/>
										<path
											className="cls-1"
											id="polygon294"
											d="m455.79 208.3-3.39.21 140.95 17.4 3.4-.22 21.83-1.36 3.41-.21-141.07-17.41-3.4.21z"
										/>
										<path
											className="cls-1"
											id="polygon296"
											d="m499.74 205.52-3.39.21 141.14 17.42 3.41-.21 21.89-1.36 3.42-.22-141.27-17.43-3.4.21z"
										/>
										<path
											className="cls-1"
											id="polygon298"
											d="m543.4 202.76-3.4.22 141.34 17.44 3.42-.21 21.94-1.37 3.43-.21-141.47-17.46-3.41.21z"
										/>
										<path
											className="cls-1"
											id="polygon300"
											d="m282.44 219.24-3.35.21 140.17 17.31 3.37-.21 21.6-1.34 3.37-.22-140.29-17.32-3.36.21z"
										/>
										<path
											className="cls-1"
											id="polygon302"
											d="m283.09 227.45-3.34.21 139.99 17.29 3.37-.21 21.57-1.34 3.37-.21-140.12-17.3-3.35.21z"
										/>
										<path
											className="cls-25"
											id="polygon304"
											d="m402.39 237.81-29.58-3.65 14.96 4.57z"
										/>
										<path
											className="cls-25"
											id="polygon306"
											d="m420.77 236.67 24.97-1.56-117.31-14.48 25.56 7.79z"
										/>
										<path
											className="cls-25"
											id="polygon308"
											d="m464.17 233.96 25.04-1.56-140.49-17.34-24.92 1.57z"
										/>
										<path
											className="cls-25"
											id="polygon310"
											d="m507.68 231.25 25.11-1.57-140.68-17.36-24.99 1.57z"
										/>
										<path
											className="cls-25"
											id="polygon312"
											d="m551.31 228.53 25.17-1.57-140.87-17.39-25.06 1.58z"
										/>
										<path
											className="cls-25"
											id="polygon314"
											d="m595.05 225.8 25.24-1.57-141.07-17.41-25.12 1.58z"
										/>
										<g id="g320">
											<path
												className="cls-25"
												id="polygon316"
												d="m541.54 202.88 29.84 3.68-15.03-4.62z"
											/>
											<path
												className="cls-25"
												id="polygon318"
												d="m615.78 220.21-25.55-7.85-67.28-8.31-25.19 1.59z"
											/>
										</g>
									</g>
								</g>
							</g>
						)}
						{walkway === 'AOG133XXX' && (
							<g id="AOG133XXX">
								<path
									className="cls-1"
									id="polygon327"
									d="m304.39 213.29 239.55-15.16 13.36 4.1-239.57 15.13z"
								/>
								<path
									className="cls-1"
									id="polygon329"
									d="m386.78 238.42 239.63-14.94 13.29 4.08-239.64 14.91z"
								/>
								<path
									className="cls-1"
									id="polygon331"
									d="M303.44 213 543 197.84l87.21 26.6-239.57 15.12z"
								/>
								<path
									className="cls-1"
									id="polygon333"
									d="m387.77 238.73 239.63-14.95 13.29 4.09-239.64 14.91z"
								/>
								<path
									className="cls-12"
									id="polygon335"
									d="m316.78 217.07 239.57-15.13 71.05 21.84-239.63 14.95z"
								/>
								<g
									clipPath="url(#clippath-2)"
									id="g373"
									style={{
										clipPath: 'url(#clippath-2)',
									}}
								>
									<g id="g371">
										<path
											className="cls-1"
											id="polygon337"
											d="m325.53 216.52-3.36.21 140.37 17.33 3.37-.21 21.66-1.35 3.38-.21-140.49-17.34-3.37.21z"
										/>
										<path
											className="cls-1"
											id="polygon339"
											d="m368.8 213.79-3.37.21 140.56 17.35 3.38-.21 21.72-1.35 3.39-.21-140.68-17.37-3.38.21z"
										/>
										<path
											className="cls-1"
											id="polygon341"
											d="m412.24 211.05-3.38.21 140.75 17.37 3.4-.21 21.77-1.36 3.4-.21-140.88-17.39-3.38.22z"
										/>
										<path
											className="cls-1"
											id="polygon343"
											d="m455.79 208.3-3.39.21 140.95 17.4 3.4-.22 21.83-1.36 3.41-.21-141.07-17.41-3.4.21z"
										/>
										<path
											className="cls-1"
											id="polygon345"
											d="m499.74 205.52-3.39.21 141.14 17.42 3.41-.21 21.89-1.36 3.42-.22-141.27-17.43-3.4.21z"
										/>
										<path
											className="cls-1"
											id="polygon347"
											d="m543.4 202.76-3.4.22 141.34 17.44 3.42-.21 21.94-1.37 3.43-.21-141.47-17.46-3.41.21z"
										/>
										<path
											className="cls-1"
											id="polygon349"
											d="m282.44 219.24-3.35.21 140.17 17.31 3.37-.21 21.6-1.34 3.37-.22-140.29-17.32-3.36.21z"
										/>
										<path
											className="cls-1"
											id="polygon351"
											d="m283.09 227.45-3.34.21 139.99 17.29 3.37-.21 21.57-1.34 3.37-.21-140.12-17.3-3.35.21z"
										/>
										<path
											className="cls-25"
											id="polygon353"
											d="m402.39 237.81-29.58-3.65 14.96 4.57z"
										/>
										<path
											className="cls-25"
											id="polygon355"
											d="m420.77 236.67 24.97-1.56-117.31-14.48 25.56 7.79z"
										/>
										<path
											className="cls-25"
											id="polygon357"
											d="m464.17 233.96 25.04-1.56-140.49-17.34-24.92 1.57z"
										/>
										<path
											className="cls-25"
											id="polygon359"
											d="m507.68 231.25 25.11-1.57-140.68-17.36-24.99 1.57z"
										/>
										<path
											className="cls-25"
											id="polygon361"
											d="m551.31 228.53 25.17-1.57-140.87-17.39-25.06 1.58z"
										/>
										<path
											className="cls-25"
											id="polygon363"
											d="m595.05 225.8 25.24-1.57-141.07-17.41-25.12 1.58z"
										/>
										<g id="g369">
											<path
												className="cls-25"
												id="polygon365"
												d="m541.54 202.88 29.84 3.68-15.03-4.62z"
											/>
											<path
												className="cls-25"
												id="polygon367"
												d="m615.78 220.21-25.55-7.85-67.28-8.31-25.19 1.59z"
											/>
										</g>
									</g>
								</g>
							</g>
						)}
					</g>
				)}
				<g id="_1projector">
					<g id="bg-2">
						<g id="LWPOLYLINE-3">
							<path
								className="cls-3"
								id="polygon377"
								d="M291.39 209.36 50.95 224.34l116.3 34.2 239.68-13.82z"
							/>
						</g>
						<g id="LWPOLYLINE-4">
							<path
								className="cls-17"
								id="polygon380"
								d="M291.39 209.36 50.95 224.34v-89.77l240.44-14.97z"
							/>
						</g>
						<g id="g389">
							<path
								className="cls-11"
								id="line383"
								d="m168.03 265.73 225.09-12.64"
							/>
							<path
								className="cls-37"
								id="polygon385"
								d="m169.21 260.67.56 9.96-8.91-4.49z"
							/>
							<path
								className="cls-37"
								id="polygon387"
								d="m391.39 248.2.56 9.95 8.34-5.46z"
							/>
						</g>
						<g id="g397">
							<path
								className="cls-11"
								id="line391"
								d="m52.89 232.55 85.43 26.6"
							/>
							<path
								className="cls-37"
								id="polygon393"
								d="m55.76 228.23-2.96 9.52-6.77-7.33z"
							/>
							<path
								className="cls-37"
								id="polygon395"
								d="m138.41 253.95-2.97 9.52 9.73-2.19z"
							/>
						</g>
						<path
							className="cls-9"
							id="polygon399"
							d="m151.96 255.44 51.85-233.31 188.47 220.35z"
						/>
						<g id="g409">
							<g id="g405">
								<path className="cls-10" id="line401" d="M206.5 20.67v208.11" />
								<path
									className="cls-28"
									id="rect403"
									d="M199.56 13.5h13.87v16h-13.87z"
								/>
							</g>
							<path
								className="cls-10"
								id="line407"
								d="m178.13 215.6 28.16 13.18"
							/>
						</g>
						<g id="g417">
							<path className="cls-11" id="line411" d="M178.67 40.98v166.15" />
							<path
								className="cls-37"
								id="polygon413"
								d="M183.65 42.44h-9.97l4.99-8.64z"
							/>
							<path
								className="cls-37"
								id="polygon415"
								d="M183.65 205.67h-9.97l4.99 8.64z"
							/>
						</g>
					</g>
					{walkway === 'AOG058XXX' && (
						<g id="AOG058XXX-2">
							<path
								className="cls-28"
								id="polygon420"
								d="m59.07 226.73 244.78-13.55 96.99 29.61-239.59 13.75z"
							/>
							<path
								className="cls-25"
								id="polygon422"
								d="m73.2 230.85 244.06-13.58 70.53 21.54-240.29 13.72z"
							/>
							<g
								clipPath="url(#clippath-3)"
								id="g466"
								style={{
									clipPath: 'url(#clippath-3)',
								}}
							>
								<g id="g428">
									<path
										className="cls-1"
										id="polygon424"
										d="m270.09 217.4-.22-3.42 185.4 23.4.04 3.33z"
									/>
									<path
										className="cls-37"
										d="m456.52 241.08-1.21-.15-186.46-23.47-.25-3.88 1.26.16 186.62 23.56.04 3.77zm-185.18-23.76 182.76 23.01-.04-2.88-182.91-23.09z"
										id="path426"
									/>
								</g>
								<g id="g434">
									<path
										className="cls-1"
										id="polygon430"
										d="m136.99 224.78-.35-3.44 189.49 23.44.17 3.34z"
									/>
									<path
										className="cls-37"
										d="m327.54 248.5-1.24-.15-190.58-23.49-.4-3.9 192.03 23.75zm-189.29-23.78 186.79 23.03-.14-2.9-186.95-23.11.31 2.98z"
										id="path432"
									/>
								</g>
								<g id="g440">
									<path
										className="cls-1"
										id="polygon436"
										d="m92.17 227.27-.4-3.44 190.89 23.44.2 3.35z"
									/>
									<path
										className="cls-37"
										d="m284.12 250.99-1.25-.15-191.97-23.5-.46-3.9 193.44 23.76.23 3.8zM93.44 227.2l188.16 23.04-.18-2.91L93.1 224.21l.35 2.98z"
										id="path438"
									/>
								</g>
								<g id="g446">
									<path
										className="cls-1"
										id="polygon442"
										d="m47.13 229.77-.45-3.45 192.28 23.45.25 3.35z"
									/>
									<path
										className="cls-37"
										d="m240.48 253.5-1.25-.15-193.38-23.51-.51-3.91L240.2 249.7ZM48.4 229.7l189.54 23.05-.22-2.91-189.7-23.13.39 2.99z"
										id="path444"
									/>
								</g>
								<g id="g452">
									<path
										className="cls-1"
										id="polygon448"
										d="m1.84 232.28-.49-3.45 193.69 23.45.3 3.37z"
									/>
									<path
										className="cls-37"
										d="m196.62 256.02-1.26-.15L.56 232.35 0 228.43l196.29 23.77.33 3.81zM3.13 232.21l190.93 23.06-.26-2.92L2.7 229.22l.43 3z"
										id="path450"
									/>
								</g>
								<g id="g458">
									<path
										className="cls-1"
										id="polygon454"
										d="m181.59 222.31-.32-3.43 188.12 23.42.12 3.34z"
									/>
									<path
										className="cls-37"
										d="m370.75 246.01-1.23-.15-189.2-23.48-.35-3.89 1.28.16 189.36 23.58zm-187.91-23.78 185.44 23.03-.11-2.9-185.6-23.1z"
										id="path456"
									/>
								</g>
								<g id="g464">
									<path
										className="cls-1"
										id="polygon460"
										d="m225.95 219.85-.27-3.43 186.76 23.42.08 3.33z"
									/>
									<path
										className="cls-37"
										d="m413.74 243.54-1.22-.15-187.82-23.48-.3-3.88 1.27.16 187.98 23.57zM227.2 219.77l184.09 23.02-.07-2.89-184.25-23.1Z"
										id="path462"
									/>
								</g>
							</g>
							<g id="g538">
								<path
									className="cls-1"
									d="m156.68 253.32 4.84-.28 1.41.41-2.87.16 1.14.33 2.45-.14 1.32.39-2.45.14 2.67.78-1.96.11-6.55-1.91z"
									id="path468"
								/>
								<path
									className="cls-1"
									d="M165.6 253.95c-1.07-.31-1.61-.57-1.63-.78-.02-.21.48-.34 1.51-.4 1.05-.06 2.16-.02 3.31.12 1.15.14 2.26.36 3.31.67.76.22 1.27.41 1.51.57.24.16.26.29.06.4-.2.11-.65.18-1.35.22-.71.04-1.42.04-2.12 0-.7-.04-1.45-.13-2.25-.26s-1.58-.31-2.34-.53zm1.96-.11c.66.19 1.25.32 1.78.4.53.07.99.09 1.4.07.41-.02.6-.08.55-.18-.05-.1-.44-.25-1.18-.46-.62-.18-1.18-.3-1.71-.37-.52-.07-.99-.09-1.4-.07-.39.02-.57.08-.52.18.05.1.41.24 1.07.44z"
									id="path470"
								/>
								<path
									className="cls-1"
									d="m176.49 254.47-6.53-1.91 3.26-.19c.6-.03 1.12-.05 1.54-.03.43.01.88.06 1.37.13.48.07.94.17 1.35.29.36.11.6.2.71.29.11.09.12.16.02.22-.06.04-.2.08-.43.11.31.01.56.02.75.04.13.01.34.04.65.08s.54.08.68.1l2.83.5-2.2.13-3.04-.52c-.39-.07-.68-.11-.86-.13-.24-.02-.45-.03-.63-.02h-.17l2.65.79-1.96.11zm-1.92-1.25.82-.05c.09 0 .23-.02.43-.06.1-.02.14-.04.11-.08-.03-.04-.11-.08-.26-.12-.21-.06-.44-.11-.68-.13-.24-.03-.54-.03-.9 0l-.86.05 1.33.39z"
									id="path472"
								/>
								<path
									className="cls-1"
									d="m176.81 252.17 1.95-.11 2.47.72-.42-.84 2.6-.15.16.85 6.46 1.05-2.4.14-4.01-.71.08.38 1.59.47-1.95.11-6.52-1.91z"
									id="path474"
								/>
								<path
									className="cls-1"
									d="m184.15 251.75 1.95-.11 4.91 1.44 3.04-.17 1.6.47-4.99.29-6.51-1.91z"
									id="path476"
								/>
								<path
									className="cls-1"
									d="m190.11 251.4 1.95-.11 6.5 1.91-1.95.11z"
									id="path478"
								/>
								<path
									className="cls-1"
									d="m193.47 251.21 4.82-.28 1.4.41-2.86.16 1.13.33 2.44-.14 1.31.39-2.44.14 2.65.78-1.95.11-6.5-1.91z"
									id="path480"
								/>
								<path
									className="cls-1"
									d="m198.89 250.9 5.92-.34 1.6.47-1.98.11 4.88 1.44-1.94.11-4.89-1.44-1.99.11-1.6-.47z"
									id="path482"
								/>
								<path
									className="cls-1"
									d="m208.18 250.37 5.91-.34 1.6.47-1.98.11 4.87 1.44-1.94.11-4.88-1.44-1.98.11-1.6-.47z"
									id="path484"
								/>
								<path
									className="cls-1"
									d="m221.47 251.89-6.47-1.91 3.24-.19c.6-.03 1.11-.04 1.54-.03.42.01.88.06 1.36.13.48.07.93.17 1.34.29.36.11.59.2.7.29.11.09.12.16.02.22-.06.04-.2.08-.43.11.31.01.56.02.74.04.12.01.34.04.65.08s.53.08.67.1l2.81.5-2.19.13-3.01-.52c-.39-.07-.67-.11-.85-.13-.24-.02-.45-.03-.63-.02h-.17l2.62.78-1.95.11zm-1.9-1.25.82-.05c.09 0 .23-.02.43-.06.1-.02.14-.04.11-.08-.03-.04-.11-.08-.25-.12-.21-.06-.43-.11-.67-.13-.24-.03-.54-.03-.89 0l-.85.05 1.32.39z"
									id="path486"
								/>
								<path
									className="cls-1"
									d="m231.06 250.97-2.2.13.76.33-1.98.11-4.1-2.05 2.12-.12 8.81 1.77-2.03.12-1.38-.3zm-1.8-.39-3.01-.65 1.64.73 1.38-.08z"
									id="path488"
								/>
								<path
									className="cls-1"
									d="m228.64 249.2 4.8-.27 1.39.41-2.85.16 1.13.33 2.43-.14 1.3.39-2.43.14 2.63.78-1.95.11z"
									id="path490"
								/>
								<path
									className="cls-1"
									d="m234.49 248.87 4.79-.27 1.38.41-2.85.16 1.12.33 2.43-.14 1.3.39-2.43.14 2.63.78-1.95.11-6.44-1.91z"
									id="path492"
								/>
								<path
									className="cls-1"
									d="m240.41 248.53 1.94-.11 6.43 1.91-1.94.11z"
									id="path494"
								/>
								<path
									className="cls-1"
									d="m251.71 249.23 2.22.06c.37.15.6.28.68.39.08.11.02.2-.17.27-.2.07-.58.12-1.14.15-.68.04-1.34.04-1.97 0-.63-.04-1.36-.12-2.19-.25-.82-.13-1.64-.32-2.43-.56-1.06-.32-1.61-.57-1.63-.78-.02-.2.47-.33 1.48-.39.79-.05 1.57-.03 2.35.04s1.62.2 2.51.39l-1.32.21-.62-.12c-.26-.04-.51-.07-.75-.08a3.52 3.52 0 0 0-.65 0c-.44.03-.59.1-.47.22.09.09.43.22 1 .39.71.21 1.31.35 1.78.42s.9.09 1.28.07c.37-.02.54-.07.52-.14-.02-.07-.2-.17-.52-.3z"
									id="path496"
								/>
								<path
									className="cls-1"
									d="m256.41 248.82 2.53-.14 1.38.41-2.53.14z"
									id="path498"
								/>
								<path
									className="cls-1"
									d="m259.32 247.45 2.87-.16c.57-.03 1.1-.03 1.61 0s1.02.08 1.54.15c.52.07 1.03.17 1.52.28.49.11.96.23 1.39.36.68.2 1.14.37 1.36.49.22.12.33.23.31.32-.02.09-.14.16-.36.2-.31.06-.63.1-.98.12l-2.87.16-6.41-1.91zm3.39.32 3.5 1.04.47-.03c.4-.02.65-.05.72-.09.07-.04.05-.09-.08-.17-.13-.08-.45-.19-.97-.34-.68-.2-1.25-.33-1.72-.4-.47-.06-.95-.08-1.45-.05l-.48.03z"
									id="path500"
								/>
								<path
									className="cls-1"
									d="m274.9 248.45-2.19.13.75.33-1.97.11-4.05-2.04 2.11-.12 8.74 1.77-2.02.12zm-1.78-.39-2.99-.65 1.62.72 1.37-.08z"
									id="path502"
								/>
								<path
									className="cls-1"
									d="m272.52 246.69 1.8-.1 5.89.92-3.53-1.06 1.82-.1 6.38 1.91-1.82.1-5.84-.91 3.51 1.05-1.81.1-6.39-1.91z"
									id="path504"
								/>
								<path
									className="cls-1"
									d="m286.99 247.31-1.33-.4 2.98-.17 2.72.81c-.17.15-.41.26-.7.33-.3.07-.74.12-1.34.15-.74.04-1.47.04-2.2-.01-.72-.05-1.47-.14-2.24-.28-.77-.14-1.48-.31-2.14-.5-.7-.21-1.16-.4-1.4-.57-.23-.17-.21-.31.06-.42.22-.09.68-.15 1.4-.19.69-.04 1.27-.05 1.74-.03.47.02.95.06 1.45.13.49.07 1 .16 1.53.28l-1.52.21c-.32-.07-.63-.12-.94-.14-.31-.03-.61-.03-.89-.02-.42.02-.61.09-.56.19.05.1.4.25 1.05.45.69.21 1.31.35 1.86.42s1.05.1 1.5.07c.22-.01.39-.03.52-.06s.25-.08.35-.14l-.6-.18-1.29.07z"
									id="path506"
								/>
								<path
									className="cls-1"
									d="m287.04 245.86 5.16-.3 1.36.41-3.23.18 1.01.3 3-.17 1.3.39-3 .17 1.25.38 3.32-.19 1.44.43-5.25.3-6.37-1.91z"
									id="path508"
								/>
								<path
									className="cls-1"
									d="m299.72 247.41-6.36-1.91 3.21-.18c.6-.03 1.1-.04 1.52-.03.42.01.87.06 1.34.13.47.07.91.17 1.32.29.35.11.58.2.69.29.11.09.11.16.01.22-.06.04-.2.08-.42.11.31.01.55.02.73.04.12.01.34.04.64.08.31.04.53.08.66.1l2.77.5-2.17.12-2.97-.52c-.38-.07-.66-.11-.84-.13-.24-.02-.44-.03-.62-.02h-.17l2.58.78-1.93.11zm-1.85-1.24.81-.05c.09 0 .23-.02.42-.06.1-.02.14-.04.11-.08-.03-.04-.11-.08-.25-.12-.21-.06-.43-.11-.66-.13-.24-.03-.53-.03-.88 0l-.85.05 1.29.39z"
									id="path510"
								/>
								<path
									className="cls-1"
									d="m302.57 244.97 5.85-.33 1.57.47-1.96.11 4.78 1.43-1.92.11-4.78-1.43-1.96.11-1.57-.47z"
									id="path512"
								/>
								<path
									className="cls-1"
									d="M311.93 245.57c-1.04-.31-1.56-.57-1.57-.78-.01-.21.49-.34 1.5-.4 1.04-.06 2.12-.02 3.24.12 1.13.14 2.2.36 3.22.67.74.22 1.22.41 1.45.57.23.16.24.29.05.39-.19.1-.64.18-1.33.22-.7.04-1.39.04-2.08 0a20.747 20.747 0 0 1-4.48-.79zm1.93-.11c.64.19 1.22.32 1.73.39s.97.09 1.37.07c.41-.02.6-.08.55-.18-.05-.1-.43-.25-1.13-.46-.6-.18-1.15-.3-1.66-.37a7.43 7.43 0 0 0-1.37-.07c-.4.02-.56.08-.51.18.05.1.39.24 1.04.44z"
									id="path514"
								/>
								<path
									className="cls-1"
									d="m319.12 244.03 3.19-.18c.69-.04 1.38-.02 2.07.06.68.08 1.33.22 1.96.4.63.18.95.35.93.48-.02.13-.41.22-1.19.26l-1.05.06 2.34.71-1.93.11-6.33-1.9zm4.63.7.47-.03c.37-.02.56-.06.58-.1.02-.05-.07-.1-.28-.16a4.12 4.12 0 0 0-.7-.14c-.27-.03-.58-.04-.94-.02l-.55.03 1.41.42z"
									id="path516"
								/>
								<path
									className="cls-1"
									d="m325.39 243.67 5.14-.29 1.35.41-3.22.18 1 .3 2.98-.17 1.29.39-2.98.17 1.24.38 3.31-.19 1.43.43-5.23.3-6.32-1.9z"
									id="path518"
								/>
								<path
									className="cls-1"
									d="m331.69 243.31 2.85-.16c.56-.03 1.09-.03 1.59 0s1.01.08 1.52.15c.52.07 1.02.17 1.5.28.49.11.94.23 1.37.36.67.2 1.12.37 1.34.49.22.12.32.23.3.32-.02.09-.14.16-.36.2-.31.06-.63.1-.97.12l-2.85.16-6.31-1.9zm3.35.32 3.45 1.04.47-.03c.4-.02.64-.05.72-.09.08-.04.05-.09-.08-.17-.13-.08-.45-.19-.95-.34-.67-.2-1.23-.33-1.69-.4-.46-.06-.94-.08-1.44-.05l-.48.03z"
									id="path520"
								/>
								<path
									className="cls-1"
									d="m338.4 242.92 5.13-.29 1.34.41-3.21.18 1 .3 2.98-.17 1.28.39-2.98.17 1.24.38 3.3-.19 1.42.43-5.22.3-6.3-1.9z"
									id="path522"
								/>
								<path
									className="cls-1"
									d="m348.53 243.86 1.7-.14c.34.09.65.15.93.19.45.07.86.09 1.23.07.27-.02.42-.05.44-.1.02-.05-.06-.1-.23-.15a3.63 3.63 0 0 0-.65-.12c-.27-.03-.72-.05-1.34-.05-1.03 0-1.88-.05-2.56-.13-.68-.08-1.26-.19-1.76-.34-.32-.1-.54-.2-.64-.29-.1-.09-.05-.18.15-.25.21-.07.63-.13 1.28-.16.79-.05 1.54-.03 2.26.03.71.07 1.44.2 2.17.39l-1.7.14a7.27 7.27 0 0 0-.92-.17c-.28-.03-.56-.04-.83-.02-.22.01-.34.04-.36.07-.02.03.04.07.18.12.1.03.24.05.41.07.17.02.46.03.87.03 1.02 0 1.8.03 2.35.07.55.04 1.04.09 1.49.17.44.07.83.16 1.18.27.4.12.66.24.78.36s.07.21-.15.29c-.22.08-.63.13-1.23.17-1.05.06-1.99.04-2.8-.06-.82-.1-1.57-.25-2.26-.44z"
									id="path524"
								/>
								<path
									className="cls-1"
									d="m350.47 242.23 5.82-.33 1.55.47-1.95.11 4.73 1.43-1.91.11-4.73-1.43-1.95.11-1.55-.47z"
									id="path526"
								/>
								<path
									className="cls-1"
									d="m363.45 243.75-6.27-1.9 3.19-.18c.59-.03 1.09-.04 1.51-.03.41.01.86.06 1.33.13.47.07.9.17 1.3.29.35.11.57.2.68.29.11.08.11.16.01.22-.06.04-.2.08-.42.11.3.01.55.02.73.04.12.01.33.04.63.08s.52.08.66.1l2.74.5-2.16.12-2.94-.52c-.38-.07-.65-.11-.83-.13-.23-.02-.44-.03-.61-.02h-.17l2.54.78-1.92.11zm-1.81-1.24.81-.05c.09 0 .23-.02.42-.05.1-.02.14-.04.11-.08-.03-.04-.11-.08-.24-.12-.2-.06-.42-.11-.66-.13-.23-.03-.53-.03-.88 0l-.84.05 1.28.39z"
									id="path528"
								/>
								<path
									className="cls-1"
									d="m363.95 241.46 1.91-.11 6.26 1.9-1.91.11z"
									id="path530"
								/>
								<path
									className="cls-1"
									d="m376.26 242.65-2.17.12.73.33-1.95.11-3.94-2.04 2.08-.12 8.57 1.77-2 .11-1.34-.3zm-1.75-.39-2.93-.64 1.57.72z"
									id="path532"
								/>
								<path
									className="cls-1"
									d="m373.96 240.89 1.78-.1 5.78.92-3.46-1.05 1.8-.1 6.24 1.9-1.8.1-5.74-.91 3.43 1.04-1.79.1-6.25-1.9z"
									id="path534"
								/>
								<path
									className="cls-1"
									d="m384.98 241.77 1.7-.14c.34.09.64.15.92.19.45.07.85.09 1.22.07.27-.02.42-.05.44-.09.02-.04-.06-.1-.23-.15-.16-.05-.38-.09-.64-.12-.27-.03-.71-.05-1.34-.05-1.03 0-1.87-.05-2.54-.13-.67-.08-1.26-.19-1.74-.34-.32-.1-.53-.2-.63-.29-.1-.09-.05-.18.16-.25.21-.07.63-.12 1.27-.16.79-.05 1.54-.03 2.25.03.71.07 1.43.2 2.15.39l-1.69.14c-.33-.08-.63-.14-.91-.17s-.56-.04-.82-.02c-.22.01-.34.04-.36.07-.02.03.04.07.18.12.1.03.23.05.41.07.17.02.46.03.87.03 1.01 0 1.79.03 2.34.07.55.04 1.04.09 1.48.17.44.07.83.16 1.17.27.4.12.66.24.78.36s.07.21-.15.29c-.22.08-.63.13-1.22.16-1.05.06-1.98.04-2.79-.06s-1.56-.25-2.24-.44z"
									id="path536"
								/>
							</g>
							<g id="g610">
								<path
									className="cls-1"
									d="m308.24 216.45-4.79.27-1.38-.42 2.85-.16-1.12-.34-2.43.14-1.29-.39 2.43-.14-2.62-.8 1.95-.11z"
									id="path540"
								/>
								<path
									className="cls-1"
									d="M299.43 215.78c1.05.32 1.58.58 1.59.79.01.21-.49.34-1.51.4s-2.14.02-3.28-.13c-1.14-.14-2.23-.37-3.26-.69-.75-.23-1.24-.42-1.48-.58-.23-.16-.25-.29-.05-.4.2-.11.65-.18 1.35-.22.7-.04 1.41-.04 2.11 0s1.44.13 2.22.27c.79.14 1.56.32 2.31.55zm-1.95.11c-.65-.2-1.23-.33-1.75-.41-.52-.07-.98-.1-1.39-.08-.41.02-.6.08-.55.18.05.1.43.26 1.15.47.6.18 1.16.31 1.68.38s.98.1 1.39.07c.41-.03.56-.08.52-.18-.05-.1-.4-.25-1.05-.45z"
									id="path542"
								/>
								<path
									className="cls-1"
									d="m288.64 215.23 6.42 1.95-3.24.18c-.6.03-1.11.04-1.53.03-.42-.01-.87-.06-1.35-.14-.48-.08-.92-.18-1.33-.3-.36-.11-.59-.21-.7-.29-.11-.09-.11-.16-.02-.23.06-.04.21-.08.43-.12-.31-.01-.56-.03-.74-.04-.12-.01-.34-.04-.65-.09-.31-.05-.53-.08-.67-.11l-2.81-.51 2.2-.12 3.01.54c.39.07.67.11.85.13.24.02.45.03.63.02h.17l-2.61-.8 1.95-.11zm1.87 1.27-.82.05c-.09 0-.23.02-.43.06-.1.02-.14.04-.11.08.03.04.11.08.25.12.21.06.43.11.67.13.24.03.54.03.89.01l.85-.05-1.31-.4z"
									id="path544"
								/>
								<path
									className="cls-1"
									d="m288.25 217.56-1.94.11-2.43-.74.39.85-2.59.14-.13-.87-6.41-1.08 2.4-.13 3.98.73-.07-.38-1.57-.48 1.95-.11 6.43 1.95z"
									id="path546"
								/>
								<path
									className="cls-1"
									d="m280.94 217.97-1.94.11-4.86-1.47-3.04.17-1.59-.48 4.99-.28 6.44 1.96z"
									id="path548"
								/>
								<path
									className="cls-1"
									d="m275 218.3-1.95.11-6.45-1.96 1.95-.11z"
									id="path550"
								/>
								<path
									className="cls-1"
									d="m271.64 218.48-4.81.27-1.39-.42 2.86-.16-1.13-.34-2.44.14-1.3-.39 2.44-.14-2.64-.8 1.96-.11 6.46 1.96z"
									id="path552"
								/>
								<path
									className="cls-1"
									d="m266.22 218.79-5.92.33-1.6-.48 1.99-.11-4.87-1.47 1.95-.11 4.87 1.47 1.99-.11z"
									id="path554"
								/>
								<path
									className="cls-1"
									d="m256.92 219.3-5.93.33-1.6-.48 1.99-.11-4.88-1.47 1.95-.11 4.88 1.47 1.99-.11z"
									id="path556"
								/>
								<path
									className="cls-1"
									d="m243.59 217.73 6.49 1.96-3.25.18c-.6.03-1.12.04-1.54.03a9.66 9.66 0 0 1-1.36-.14c-.48-.08-.93-.18-1.34-.3-.36-.11-.6-.21-.71-.29-.11-.09-.12-.16-.02-.23.06-.04.21-.08.43-.12-.31-.01-.56-.03-.75-.04-.12-.01-.34-.04-.65-.09-.31-.04-.54-.08-.68-.11l-2.83-.52 2.21-.12 3.03.54c.39.07.67.11.85.13.24.02.45.03.63.02h.17l-2.64-.8 1.96-.11zm1.9 1.27-.82.05c-.09 0-.23.02-.43.06-.1.02-.14.04-.11.08.03.04.11.08.25.12.21.06.43.11.68.13.24.03.54.03.9.01l.86-.05-1.32-.4z"
									id="path558"
								/>
								<path
									className="cls-1"
									d="m233.93 218.64 2.22-.12-.76-.34 2-.11 4.12 2.09-2.13.12-8.88-1.83 2.05-.11 1.39.31zm1.81.4 3.03.66-1.64-.74z"
									id="path560"
								/>
								<path
									className="cls-1"
									d="m236.36 220.44-4.83.27-1.4-.42 2.87-.16-1.14-.34-2.45.14-1.31-.4 2.45-.14-2.66-.8 1.97-.11z"
									id="path562"
								/>
								<path
									className="cls-1"
									d="m230.46 220.77-4.84.27-1.4-.42 2.87-.16-1.14-.34-2.45.14-1.32-.4 2.46-.14-2.66-.8 1.97-.11z"
									id="path564"
								/>
								<path
									className="cls-1"
									d="m224.49 221.1-1.96.11-6.52-1.96 1.96-.11z"
									id="path566"
								/>
								<path
									className="cls-1"
									d="m213.05 220.37-2.25-.07c-.38-.16-.61-.29-.7-.4-.08-.11-.03-.21.17-.28.2-.07.58-.12 1.15-.15.69-.04 1.36-.04 2 0 .64.04 1.38.13 2.22.26.84.14 1.66.33 2.47.57 1.08.32 1.63.59 1.65.79.02.2-.48.34-1.5.39-.8.04-1.59.03-2.38-.04-.79-.07-1.64-.21-2.55-.4l1.33-.21c.26.06.47.1.63.12.26.04.52.07.76.08.24.02.46.02.66 0 .44-.02.6-.1.47-.22-.09-.09-.43-.23-1.02-.4-.72-.22-1.33-.36-1.81-.43s-.92-.09-1.3-.07c-.38.02-.55.07-.53.14.02.08.2.18.53.31z"
									id="path568"
								/>
								<path
									className="cls-1"
									d="m208.29 220.78-2.56.14-1.41-.42 2.56-.14z"
									id="path570"
								/>
								<path
									className="cls-1"
									d="m205.35 222.17-2.91.16c-.57.03-1.12.03-1.63 0-.52-.03-1.04-.08-1.57-.16s-1.05-.17-1.55-.29c-.5-.11-.98-.24-1.43-.37-.7-.21-1.17-.38-1.4-.5-.23-.12-.34-.23-.33-.33.01-.09.14-.16.36-.2.31-.06.64-.1.99-.12l2.92-.16 6.55 1.96zm-3.44-.33-3.58-1.07-.48.03c-.41.02-.66.05-.74.09-.08.04-.05.09.08.17.13.08.47.19.99.35.69.21 1.28.34 1.76.41.48.06.97.08 1.48.05z"
									id="path572"
								/>
								<path
									className="cls-1"
									d="m189.47 221.11 2.23-.12-.77-.34 2.01-.11 4.17 2.09-2.14.12-8.96-1.83 2.06-.11 1.4.31zm1.83.4 3.06.67-1.66-.74-1.4.08z"
									id="path574"
								/>
								<path
									className="cls-1"
									d="m191.94 222.91-1.83.1-6.03-.95 3.63 1.08-1.85.1-6.58-1.96 1.86-.1 5.99.94-3.61-1.08 1.85-.1 6.57 1.96z"
									id="path576"
								/>
								<path
									className="cls-1"
									d="m177.15 222.25 1.37.41-3.04.17-2.81-.84c.17-.15.41-.27.71-.34s.76-.12 1.37-.15c.76-.04 1.51-.04 2.25.02a21.58 21.58 0 0 1 4.51.81c.72.21 1.2.41 1.44.58.24.17.23.32-.05.43-.22.09-.69.15-1.42.19-.7.04-1.3.05-1.78.03-.48-.02-.97-.06-1.48-.13s-1.03-.16-1.57-.28l1.55-.21c.33.07.65.12.97.15.32.03.62.04.91.02.43-.02.62-.09.57-.2-.05-.11-.42-.26-1.09-.46-.71-.21-1.35-.36-1.92-.43-.56-.08-1.08-.1-1.54-.08-.22.01-.4.03-.53.06s-.25.08-.35.14l.62.18 1.32-.07z"
									id="path578"
								/>
								<path
									className="cls-1"
									d="m177.14 223.73-5.28.29-1.41-.42 3.3-.18-1.05-.31-3.07.17-1.34-.4 3.07-.17-1.3-.39-3.4.19-1.5-.44 5.38-.3 6.59 1.96z"
									id="path580"
								/>
								<path
									className="cls-1"
									d="m164.09 222.13 6.6 1.96-3.28.18c-.61.03-1.13.04-1.56.03-.43-.01-.89-.06-1.38-.14-.49-.08-.95-.18-1.37-.3-.37-.11-.61-.21-.72-.29-.11-.09-.12-.16-.02-.23.06-.04.21-.08.43-.12-.32-.01-.57-.03-.76-.04-.13-.01-.35-.04-.66-.09-.32-.05-.54-.08-.69-.11l-2.87-.52 2.23-.12 3.07.54c.39.07.68.11.87.13.24.02.46.03.64.02h.17l-2.68-.81 1.98-.11zm1.95 1.28-.83.05c-.09 0-.23.02-.43.06-.1.02-.14.04-.11.08.03.04.11.08.26.12.21.06.44.11.69.13.24.03.55.03.91.01l.87-.05-1.34-.4z"
									id="path582"
								/>
								<path
									className="cls-1"
									d="m161.26 224.62-6 .33-1.63-.48 2.01-.11-4.98-1.48 1.98-.11 4.98 1.48 2.01-.11z"
									id="path584"
								/>
								<path
									className="cls-1"
									d="M151.61 223.99c1.08.32 1.63.59 1.65.8.02.21-.49.34-1.52.4-1.06.06-2.18.02-3.35-.13a19.88 19.88 0 0 1-3.35-.69c-.77-.23-1.28-.42-1.53-.59-.24-.16-.27-.3-.07-.4.2-.11.65-.18 1.36-.22.71-.04 1.44-.04 2.15 0s1.47.13 2.28.27c.81.14 1.6.32 2.37.55zm-1.98.11c-.67-.2-1.27-.33-1.8-.41-.53-.07-1-.1-1.42-.08-.42.02-.61.08-.56.18.05.1.45.26 1.19.48.62.18 1.2.31 1.73.38s1 .1 1.42.07c.42-.03.57-.08.52-.18-.05-.1-.41-.25-1.09-.45z"
									id="path586"
								/>
								<path
									className="cls-1"
									d="m144.27 225.56-3.28.18c-.72.04-1.43.02-2.14-.07-.71-.08-1.39-.22-2.04-.42-.67-.2-1-.36-.99-.5.01-.14.42-.22 1.21-.27l1.08-.06-2.46-.73 1.99-.11 6.63 1.96zm-4.81-.73-.48.03c-.38.02-.58.06-.6.11-.02.05.08.11.3.17.22.06.45.11.73.15.28.04.6.04.97.02l.56-.03-1.48-.44z"
									id="path588"
								/>
								<path
									className="cls-1"
									d="m137.82 225.92-5.3.29-1.42-.42 3.32-.18-1.06-.31-3.08.17-1.36-.4 3.08-.17-1.31-.39-3.42.19-1.51-.45 5.4-.3 6.64 1.96z"
									id="path590"
								/>
								<path
									className="cls-1"
									d="m131.33 226.28-2.94.16c-.58.03-1.13.03-1.65 0s-1.05-.08-1.59-.16-1.06-.17-1.57-.29c-.51-.11-.99-.24-1.45-.37-.71-.21-1.19-.38-1.42-.5-.24-.12-.35-.23-.34-.33.01-.09.13-.16.36-.21.31-.06.65-.1 1-.12l2.94-.16 6.65 1.96zm-3.48-.33-3.64-1.07-.49.03c-.41.02-.66.05-.74.09-.08.04-.05.09.09.17.14.08.47.19 1.01.35.71.21 1.3.34 1.78.41.48.06.98.08 1.49.05l.49-.03z"
									id="path592"
								/>
								<path
									className="cls-1"
									d="m124.4 226.66-5.31.29-1.42-.42 3.32-.18-1.06-.31-3.08.17-1.36-.4 3.09-.17-1.31-.39-3.42.19-1.51-.45 5.41-.3 6.66 1.96z"
									id="path594"
								/>
								<path
									className="cls-1"
									d="m113.81 225.69-1.76.14c-.36-.09-.69-.16-.98-.2-.47-.07-.9-.09-1.28-.07-.28.02-.43.05-.45.1-.02.05.07.1.25.15.17.05.4.09.68.12s.75.05 1.4.06c1.07.01 1.96.06 2.67.14.71.08 1.33.19 1.85.35.34.1.57.2.68.3.11.1.07.19-.14.26-.21.07-.65.13-1.32.16-.82.05-1.6.03-2.35-.04s-1.51-.2-2.28-.4l1.76-.14c.35.09.67.14.97.18.3.03.58.04.86.02.23-.01.35-.04.37-.07.02-.04-.05-.08-.2-.12-.11-.03-.25-.06-.43-.08-.18-.02-.49-.03-.91-.04-1.06 0-1.88-.03-2.45-.07-.57-.04-1.09-.1-1.56-.17-.47-.08-.88-.17-1.24-.28-.43-.13-.71-.25-.84-.37s-.09-.22.13-.3c.22-.08.64-.13 1.27-.17 1.09-.06 2.07-.04 2.93.07.86.11 1.65.26 2.38.45z"
									id="path596"
								/>
								<path
									className="cls-1"
									d="m111.91 227.36-6.03.33-1.65-.48 2.02-.11-5.04-1.48 1.99-.11 5.03 1.48 2.02-.11 1.65.48z"
									id="path598"
								/>
								<path
									className="cls-1"
									d="m98.27 225.78 6.69 1.96-3.31.18c-.61.03-1.14.04-1.57.03-.43-.01-.9-.06-1.39-.14-.5-.08-.96-.18-1.38-.3-.37-.11-.62-.21-.73-.29-.12-.09-.13-.16-.03-.23.06-.04.21-.08.43-.12-.32-.01-.57-.03-.76-.04-.13-.01-.35-.04-.67-.09-.32-.05-.55-.08-.69-.11l-2.91-.52 2.25-.12 3.11.54c.4.07.69.11.88.13.25.02.46.03.64.02h.18l-2.72-.81 2-.11zm1.99 1.28-.84.05c-.09 0-.24.02-.43.06-.1.02-.14.04-.11.08.03.04.12.08.26.12.22.06.45.11.69.14.25.03.55.03.91 0l.87-.05-1.36-.4z"
									id="path600"
								/>
								<path
									className="cls-1"
									d="m97.92 228.14-1.99.11-6.7-1.97 1.99-.11z"
									id="path602"
								/>
								<path
									className="cls-1"
									d="m84.95 226.9 2.26-.13-.79-.34 2.03-.11 4.29 2.1-2.17.12-9.13-1.83 2.08-.12zm1.86.4 3.12.67-1.71-.75z"
									id="path604"
								/>
								<path
									className="cls-1"
									d="m87.51 228.71-1.86.1-6.14-.95 3.72 1.09-1.88.1-6.72-1.97 1.88-.1 6.1.95-3.69-1.08 1.87-.1 6.71 1.97z"
									id="path606"
								/>
								<path
									className="cls-1"
									d="m75.88 227.8-1.77.14c-.36-.09-.69-.16-.99-.2-.48-.07-.91-.09-1.29-.07-.28.02-.43.05-.45.1-.02.05.07.1.25.15.18.05.4.09.69.12.28.03.75.05 1.41.06 1.08.01 1.97.06 2.69.14.71.08 1.33.19 1.86.35.35.1.58.2.69.3.12.1.07.19-.14.26-.21.07-.65.13-1.32.17-.82.05-1.61.03-2.36-.04-.75-.07-1.52-.2-2.3-.4l1.76-.14c.35.09.68.14.97.18.3.03.59.04.87.02.23-.01.35-.04.37-.07.01-.04-.05-.08-.2-.12-.11-.03-.25-.06-.43-.08-.18-.02-.49-.03-.92-.04-1.07 0-1.89-.03-2.47-.07-.58-.04-1.1-.1-1.57-.17-.47-.08-.89-.17-1.25-.28-.43-.13-.72-.25-.85-.37-.14-.12-.09-.22.13-.3.22-.08.65-.13 1.27-.17 1.1-.06 2.08-.04 2.94.07.86.11 1.66.26 2.4.45z"
									id="path608"
								/>
							</g>
						</g>
					)}
					{walkway === 'AOG059XXX' && (
						<g id="AOG059XXX-2">
							<path
								className="cls-1"
								id="polygon613"
								d="m59.07 226.73 244.78-13.55 96.99 29.61-239.61 13.89z"
							/>
							<path
								className="cls-30"
								id="polygon615"
								d="m68.02 229.35 244.33-13.58 80.21 24.49-240.05 13.86z"
							/>
							<path
								className="cls-25"
								id="polygon617"
								d="m59.59 226.88 244.76-13.55 9.82 2.99-244.23 13.59z"
							/>
							<path
								className="cls-25"
								id="polygon619"
								d="m150.64 253.57 240.14-13.85 9.58 2.92-239.64 13.89z"
							/>
							<path
								className="cls-1"
								id="polygon621"
								d="m69.94 229.91 244.23-13.59.49.15-244.21 13.59z"
							/>
							<path
								className="cls-1"
								id="polygon623"
								d="m150.38 253.5 240.16-13.85.48.14-240.13 13.86z"
							/>
						</g>
					)}
					{walkway === 'AOG061XXX' && (
						<g id="AOG061XXX-2">
							<path
								className="cls-1"
								id="polygon626"
								d="m172.82 220.48 19.41-1.1 99.18 29.84-19.03 1.12z"
							/>
							<path
								className="cls-25"
								id="polygon628"
								d="m152.44 221.63 19.45-1.1 99.58 29.86-19.09 1.13z"
							/>
							<path
								className="cls-25"
								id="polygon630"
								d="m193.15 219.33 19.36-1.09 98.8 29.81-18.99 1.12z"
							/>
							<path
								className="cls-1"
								id="polygon632"
								d="m213.43 218.19 19.3-1.1 98.42 29.8-18.94 1.11z"
							/>
							<path
								className="cls-1"
								id="polygon634"
								d="m132 222.79 19.51-1.11 99.96 29.89-19.13 1.13z"
							/>
							<path
								className="cls-25"
								id="polygon636"
								d="m111.51 223.94 19.56-1.1 100.36 29.91-19.19 1.13z"
							/>
							<path
								className="cls-25"
								id="polygon638"
								d="m233.65 217.04 19.26-1.09 98.04 29.77-18.9 1.11z"
							/>
							<path
								className="cls-1"
								id="polygon640"
								d="m59.59 226.88 9.85-.56 101.53 29.98-9.66.57z"
							/>
							<path
								className="cls-1"
								id="polygon642"
								d="m294.01 213.63 9.56-.54 97.09 29.71-9.38.55z"
							/>
							<path
								className="cls-1"
								id="polygon644"
								d="m253.82 215.9 19.21-1.08 97.66 29.74-18.84 1.11z"
							/>
							<path
								className="cls-1"
								id="polygon646"
								d="m90.97 225.11 19.61-1.11 100.75 29.93-19.24 1.13z"
							/>
							<path
								className="cls-25"
								id="polygon648"
								d="m273.95 214.77 19.15-1.09 97.28 29.72-18.79 1.11z"
							/>
							<path
								className="cls-25"
								id="polygon650"
								d="m70.38 226.27 19.66-1.11 101.14 29.95-19.29 1.14z"
							/>
						</g>
					)}
					{walkway === 'AOG131XXX' && (
						<g id="AOG131XXX-2">
							<path
								className="cls-1"
								id="polygon653"
								d="m60.58 227.17 243.82-13.99 13.45 4.12-243.24 14.01z"
							/>
							<path
								className="cls-1"
								id="polygon655"
								d="m146.57 252.52 240.34-14.08 13.16 4.04-239.78 14.09z"
							/>
							<path
								className="cls-25"
								id="polygon657"
								d="m59.59 226.88 243.85-13.99 13.46 4.12-243.28 14.01z"
							/>
							<path
								className="cls-25"
								id="polygon659"
								d="m147.6 252.83 240.29-14.08 13.16 4.03-239.74 14.09z"
							/>
							<path
								className="cls-12"
								id="polygon661"
								d="m73.62 231.02 243.28-14.01 70.99 21.74-240.29 14.08z"
							/>
							<g
								clipPath="url(#clippath-4)"
								id="g699"
								style={{
									clipPath: 'url(#clippath-4)',
								}}
							>
								<g id="g697">
									<path
										className="cls-1"
										id="polygon663"
										d="m82.65 230.5-3.47.2 144.26 17.68 3.4-.2 21.82-1.27 3.39-.2-143.73-17.69-3.46.2z"
									/>
									<path
										className="cls-1"
										id="polygon665"
										d="m127.15 227.93-3.46.2 143.46 17.69 3.4-.2 21.73-1.27 3.39-.2-142.94-17.69-3.45.2z"
									/>
									<path
										className="cls-1"
										id="polygon667"
										d="m171.54 225.38-3.44.2 142.67 17.69 3.38-.2 21.66-1.27 3.38-.2-142.16-17.69-3.43.2z"
									/>
									<path
										className="cls-1"
										id="polygon669"
										d="m215.78 222.83-3.43.2 141.89 17.69 3.37-.2 21.58-1.26 3.37-.2-141.38-17.69-3.42.2z"
									/>
									<path
										className="cls-1"
										id="polygon671"
										d="m260.16 220.28-3.42.19 141.1 17.69 3.35-.19 21.52-1.26 3.35-.2-140.59-17.69-3.41.2z"
									/>
									<path
										className="cls-1"
										id="polygon673"
										d="m303.96 217.76-3.4.19 140.32 17.69 3.35-.19 21.43-1.26 3.34-.2-139.81-17.69-3.4.2z"
									/>
									<path
										className="cls-1"
										id="polygon675"
										d="m38.06 233.06-3.48.2 145.06 17.69 3.42-.2 21.89-1.28 3.41-.2-144.54-17.69-3.47.2z"
									/>
									<path
										className="cls-1"
										id="polygon677"
										d="m39.16 241.3-3.48.2 144.74 17.55 3.41-.2 21.84-1.28 3.41-.2-144.22-17.55-3.46.2z"
									/>
									<path
										className="cls-25"
										id="polygon679"
										d="m162.49 251.95-30.4-3.69 15.51 4.57z"
									/>
									<path
										className="cls-25"
										id="polygon681"
										d="m181.17 250.86 25.3-1.48-120.63-14.76 26.7 7.87z"
									/>
									<path
										className="cls-25"
										id="polygon683"
										d="m225.09 248.29 25.21-1.48-143.77-17.69-25.67 1.48z"
									/>
									<path
										className="cls-25"
										id="polygon685"
										d="m268.85 245.72 25.13-1.47L151 226.56l-25.58 1.47z"
									/>
									<path
										className="cls-25"
										id="polygon687"
										d="m312.46 243.17 25.04-1.47-142.19-17.69-25.49 1.47z"
									/>
									<path
										className="cls-25"
										id="polygon689"
										d="m355.92 240.62 24.95-1.46-141.4-17.69-25.4 1.46z"
									/>
									<g id="g695">
										<path
											className="cls-25"
											id="polygon691"
											d="m302.09 217.86 29.92 3.78-15.11-4.63z"
										/>
										<path
											className="cls-25"
											id="polygon693"
											d="m376.35 235.21-25.46-7.79-67.42-8.48-25.31 1.45z"
										/>
									</g>
								</g>
							</g>
						</g>
					)}
					{walkway === 'AOG133XXX' && (
						<g id="AOG133XXX-2">
							<path
								className="cls-1"
								id="polygon702"
								d="m60.58 227.17 243.82-13.99 13.45 4.12-243.24 14.01z"
							/>
							<path
								className="cls-1"
								id="polygon704"
								d="m146.57 252.52 240.34-14.08 13.16 4.04-239.78 14.09z"
							/>
							<path
								className="cls-1"
								id="polygon706"
								d="m59.59 226.88 243.85-13.99 84.33 25.84-243.28 14z"
							/>
							<path
								className="cls-1"
								id="polygon708"
								d="m147.6 252.83 240.29-14.08 13.16 4.03-239.74 14.09z"
							/>
							<path
								className="cls-12"
								id="polygon710"
								d="m73.62 231.02 243.28-14.01 70.99 21.74-240.29 14.08z"
							/>
							<g
								clipPath="url(#clippath-5)"
								id="g748"
								style={{
									clipPath: 'url(#clippath-5)',
								}}
							>
								<g id="g746">
									<path
										className="cls-1"
										id="polygon712"
										d="m82.65 230.5-3.47.2 144.26 17.68 3.4-.2 21.82-1.27 3.39-.2-143.73-17.69-3.46.2z"
									/>
									<path
										className="cls-1"
										id="polygon714"
										d="m127.15 227.93-3.46.2 143.46 17.69 3.4-.2 21.73-1.27 3.39-.2-142.94-17.69-3.45.2z"
									/>
									<path
										className="cls-1"
										id="polygon716"
										d="m171.54 225.38-3.44.2 142.67 17.69 3.38-.2 21.66-1.27 3.38-.2-142.16-17.69-3.43.2z"
									/>
									<path
										className="cls-1"
										id="polygon718"
										d="m215.78 222.83-3.43.2 141.89 17.69 3.37-.2 21.58-1.26 3.37-.2-141.38-17.69-3.42.2z"
									/>
									<path
										className="cls-1"
										id="polygon720"
										d="m260.16 220.28-3.42.19 141.1 17.69 3.35-.19 21.52-1.26 3.35-.2-140.59-17.69-3.41.2z"
									/>
									<path
										className="cls-1"
										id="polygon722"
										d="m303.96 217.76-3.4.19 140.32 17.69 3.35-.19 21.43-1.26 3.34-.2-139.81-17.69-3.4.2z"
									/>
									<path
										className="cls-1"
										id="polygon724"
										d="m38.06 233.06-3.48.2 145.06 17.69 3.42-.2 21.89-1.28 3.41-.2-144.54-17.69-3.47.2z"
									/>
									<path
										className="cls-1"
										id="polygon726"
										d="m39.16 241.3-3.48.2 144.74 17.55 3.41-.2 21.84-1.28 3.41-.2-144.22-17.55-3.46.2z"
									/>
									<path
										className="cls-25"
										id="polygon728"
										d="m162.49 251.95-30.4-3.69 15.51 4.57z"
									/>
									<path
										className="cls-25"
										id="polygon730"
										d="m181.17 250.86 25.3-1.48-120.63-14.76 26.7 7.87z"
									/>
									<path
										className="cls-25"
										id="polygon732"
										d="m225.09 248.29 25.21-1.48-143.77-17.69-25.67 1.48z"
									/>
									<path
										className="cls-25"
										id="polygon734"
										d="m268.85 245.72 25.13-1.47L151 226.56l-25.58 1.47z"
									/>
									<path
										className="cls-25"
										id="polygon736"
										d="m312.46 243.17 25.04-1.47-142.19-17.69-25.49 1.47z"
									/>
									<path
										className="cls-25"
										id="polygon738"
										d="m355.92 240.62 24.95-1.46-141.4-17.69-25.4 1.46z"
									/>
									<g id="g744">
										<path
											className="cls-25"
											id="polygon740"
											d="m302.09 217.86 29.92 3.78-15.11-4.63z"
										/>
										<path
											className="cls-25"
											id="polygon742"
											d="m376.35 235.21-25.46-7.79-67.42-8.48-25.31 1.45z"
										/>
									</g>
								</g>
							</g>
						</g>
					)}
					<g id="worker">
						<g
							id="g753"
							style={{
								mixBlendMode: 'darken',
							}}
						>
							<image
								width={636}
								height={388}
								transform="matrix(.24 0 0 .24 222.18 179.55)"
								xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAnkAAAGCCAYAAACctNXmAAAACXBIWXMAAC4jAAAuIwF4pT92AAAgAElEQVR4nO3d+3Ib2XXv8d3daIAgRUojKU5cFZ+Z0R/xA8R5AM/LJJXL0/hS9oOcOnX+GT9Ach7A+UOyyyk7mWjGQ1IgCKAvp1Zrr87qjd0XkJREid9PVVcDIAhBEgj8uNa+OAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA+5LwLw3gfajr+k7fb5IkqfmPA4B+hDwAe+4ykCXJu32bqeu7y3oERwCfEkIe8ABMDW03CWQ/+8WvJn3Tixdf3un7zcuXryYFsn/5p384OLhNDY6EQgD3GSEP+IiNhbdYaJsSyg4JZL/5+uv28udfxL/v+fPn7e3//tvfTn3oqL/58Y/bm1+/fh0NWb//3f8EwJ9+9dXkx54SHGOhcSwUEgYBfAiEPOCeGgpwYXgbCm5hYBsLZYcEsqfPnu19/+PHj5vb/uMPf2iun56dtfc5OTlpL//3N98MPnboL37wg/aW1WrVhqbLi4vm8l//6EfN9fPz871A9d233w6GrLHgOBQah4JhGAiHwiBBEMBdI+QBH1BfkJsa4jTAaXAbCm0a2Gww00DmfCi7SSA7NvdbLpfN5T9/95078pcXi0VycXHRnO33hdfHbDabTgiS62dnZ+3t1+t1/dnTp83X1ut1e98rEwhDQ8FRQ6MLgqMGRg2GQ6FQA2FfEJwaAgmAAG6CkAe8B7EwZ4NcLMTZClwsxNnwFgtuNrRpYJOwpqHsNoHs8vKy81zn83mi59WbNy7313e7XZLneXNZzldXV06v39Rut6uPj4+bs/8z6jzP317ebuuTR4/cdrttrutZnZ6edv7UmwRHCY0aDjUY2lAYBsJYGAxDoOsJghoCCX8AboKQB9yhoTA3FOT6QlxYfZMAF4a3MLgNhTY5S0CTMHbTQDabzdrbrq+vO7fJuSiK5nJZlkmWZYme9TY56/VDlWVZ+++v/ePVclnP/jnURVE0l/V8dHTU/kl6mzU1OMohQVFDYF8oDANhGAY1CNqqYBgCh6qAhD8AUxDygBsKA91QZc6GuViQmxrirtfrRAPcZrNJJLSFwW273e6FNntZQpiEsZsGMrm+3W471/UcPo49y32qqkrSNG0u67koisH/gNls5vz31npO07QNe2HQs2dngqF7W2nsXHcHBkc55LILg6C5PJ/P6zAQyrFYLNogeLRc9obA07Oz9vk9f/68uawB0IY/FwmAQ+GP4Ac8PIQ8YIKpgW5qmLu8uEhskFutVp0QZytwckigc2+rSolU3jS06VmDm57DkDUU6EywSw8JZPZrcruc5ZDvM9+b6mU92/sf8tqTcCeBT84a9Ezgq/Sy3m7v70xIdBODo9zcFyCdCX7h1zQI6lkDYHvebut8Pm8eQ4JfGAKXy2UtlUAbAMMK4FD46wt+LhL+CH7Ap42QB0T0hbqxQBerzJ2fnzeXr1arRCpy0lJdr9edapxU36QK1xfiJCxpULPhbLFYpPY2uZ/9+nw+b66HQSsWwg4JZHq7XtbrWZal8m8nR/L2H625nkqC8rfpv23k37hzvQ4SiQaStw/RPJgEucrfXultcpRlWdlA6Hyws0HPHRAc7eXwLMFuu91WQQhsA6IEvc1m0/m6aSlXfSFQA6CebQXw5OSkvk3466v4fejQ1zPcgSAK3BAhDzgg1A0FOq3OxSpzGuYk9GhL1QY4rcDZkBa7rKFNr+d53gQzDWiz2Sx6XW/TAKe32wA2NZDZMKa3631tsJNzX9Crqir6OCH7AS8hLk1T1xfw5BwGPg2K4eOYv8tgcLTX5ekXRVFp0JOva+VQb9fbwuu73a7S8GdDoYZBvV3C3/X1tQTU5vJ6va4k+MlxtVpVuW8Fz00I1PAXVv607auTP8Lg9yFD39hEpMj938vzAj41hDw8SDcJdd99+20SBrqwOqetVa3MScAJw5ycj46O2ssa2myA09uTJEl9Fa8Nb3qE12P3GQpb9utDQc8GMr3uTNizQS/2Z+ptej18zAkLOmsAaUOeDXJyuS/ohd/v3v5l28tDwVGv28ccC5d6aNALb4tdl/vVdV1p0LP38eP/Kq0E6m2x8BdW/mzb9/jkZC/4PX327L2HPvNa2ft5s+Rnb2jZGfu8CHxAP0IeHoygGtWc+0KdrdJpy1UrdBrobKs1cS7NTahbLpdtiLOHhrgsy7Lwa+/q0NAVhr3wtrFAZgOeC0KereQNPHYSOdqH63kd1sHl8OgEPA1ctpIXhjxngt5YcIw9dt9ttz2qqiqDgKePv/fYcpsEPxsMbfhr2sDbrTzJSqp+Gv40+Gm79/Hjx7W0em21765DX/hzpz9zQ+NX9XJsxnH4vAh8QD9CHj5Zh4Q6Zyp1YagzM1pTCXSPHj1K/QzWJtBptU3OMkbOB6XU378NTzbYVVWV+Qpaey6KonmMJEkyE5KyqqpSez0IZHthMXKfaOiyt9tK3kggsy1WDXqJuWy/1z5WeHaxx+yhH9z2XEXOlQmAGtj8U20vu8hjRYOjreSFYW4o5NV1XUZCWdl3H/s1uT1N0/brEvwk7GkA1LPcpuGvLMv2+7XyJ4e0ff1jtsFPAt+bN2+ac3Mf3+qNhb6bVPpiwmDX94tUuBi3suMO7fN68eLLWp9T+HwIe8BbhDx8UoaC3U1DnVTpXJKkx8fHbXjbbDadYGUDnAY2G+A01MlZrksQ04AmZw1m4WUb2sLrsZAXBrzgiAWvvsv27MKzCXXOhjxfzet7nDA8ugPeg2KhLBb0JH/Zal77vUHQOzQ4jl2u+kLcWJCTs35dL9v72NuyLGuCXiz82et62AAox2KxaCuBV1dXlavrSqt9dxH6LPsL1e9/9yrRYPf69evenzmdVS7s+oO2Avmff/pTJW1nfU7h87HVPcIeHjpCHj56U4Pd2AeMhh6Z4epMdc6Pd2vDU1nKZ23WCW32cnjWQKcBTs5pms7C28Kgp1W8gZBnA11Yves8/5Gq2tDX+gLZ3uWgbbv3OHq7rQC6/cDYEQYzva5BLgx8QcALg1zf5bHgGA2TQajra62W4WUNd7Fgd5uzH+dXagiUyxoA9XL59sXbPqeiKEr7/CX0+eVdqqHQJ7N4tZUqFTUXzN7VVuzLl6/C8aypjGN99vx56meYtz9zdla5Po7OOpYQKv+2FxcXlV9qprKBT59PWN2jlYuHjpCHj9JNg134AWMrdbFQp4FOyGUNcTbIzd6WUGxQm9nwJtfD2/suB0EuM+Gt77wX8IaqeFMrbQcGsiS4nz3Cxwzbu+1j9LwO2w/mSPs1Fs7aI6zkRR7HTQmOfZXCWNjrOfaCXnBub7NBT5YltKFPrscu61mOqqo63yPhrnhbVm6Dn15++5J+S4NfLPTZSp9U1L59/boKJ3LYpVvC7fZkktJf/fCHqZ9x3r4m8zxvXrfr9bq5rpORdPcUuwZh+O+63W7l79iseyPk+cjtseoerVw8ZIQ8fFT6Zuf52XjNZQ12ZsHhVKp1j5880VZroh8yUvG6vr7uDXU2xEkY03OWZTMNcBrSwjCnXwtvC0LezIS58GgCnDzHWPUuuH3vMIEutcEtFsB6Ql4skHXG5Lnukio2DO5NxgiWWYk+Vig2ji6cVBGbZGGCWjvhYuCx3MTgWJkAaQNhFQS/aPs2qPL1hb3wKMz1vZCnQdAGvPBr/jGay2VZNpd9Za+wIbAv9B0dHTUVyt1uV8Yqajp7N/y/05nn+jO3WCwy/bnb7XbycyXDGpqfNR27amaYK11fUMciyvMt9Tyfz0sJfPbfWquN/vre2D3CHh4SQh7uvaHZeWHFLgx2zSq9MpnBV+u0emA/YDTYxULdTY9YyPNHFjlHw11fO1ZbsWYc3iFVu73jJoEsVs2LnJNY8LP3i8zWbBNXcHv7xzsT9Mxt9mjvN1LF23u8geDYd4xW99qqmJkZe2DYK0Yut6EuDHaHHrHQFwt/wTi/WkKfjqEL9ktuX5f6Myevf3ko/ZnwQx9mej+zIHdt1hpsn5f9O0nYW6/XRZ7nTdg7PT2V+zYHrVyAkId7zFbtprRi9UNCqgYa7PL5vAlH8uEiHzJmPF3zQZPn+WCgS5Ikr6qqOZuqXa5fGwmBh4a7oZZs5zBr0fWOp7NLoYyEroMDWc8YuljVLxn4WmtiJc/FKnDm9r6v2T+nve2Q4DgSKqsgDO61ec2Yvb1qX1DlK831QwNfEVzuHHVd73wI3Ontcluapu3XYocEq91uV/iAV/SFPRk7d3x87K6urpzu1iKvT/m5swEvy7J8t9vN0jRtfn7kbH4G7ULcGvAqrUDOZrOiqqqdHHmey3PpPG+pNkrgi1VTaeXiISLk4V4ZqtpJOzYW7GzFbu5DnXyoSBv26OhoJh8uWjmQUKfBqyiK9rJ+4IShTgKdXLa3x0JeXdcaCmMhbyzYdULdSKVur0oXuRy2ZmOBzg1dPiSQjYzRa69H7nvo+09nfJ77n6A2GO4GqoKdxx0KjrHLYfCLTProtHUjLd2+9m4ZhL++Vm4Y9johr65rCXSFDXQa8my4k0ODXxj6JEz1BT9/uZ3Bq3v6urdbyDVb8GmF3P6cVVXVHFmWzeVnSX+etOqt7wGyfqGZqFLo80zTdFcUxVbOzrltlmU7DXty1jC6227LR6ensp5gG/po5eKhIeThXhir2sVm5+n6cW8uL5uKnVYLbNUgPORDRsKdnDXA2TA3cpbHyP0xM+e+Cl7mx9Q1Y+/MGLposDMfcHsVuliQG2rBhpMhei67uwhkAxW+TgWwr/o38fXXW5WLLIvSV7EbfNwpwbFn7b1wkkdva7cnAPYFvs6yKxr4BsJfrLJnDw1sct75ENiGvL6zDVhh8NNJHFqpnM/nbrvdOt2Kz8w2b8NdkiRz51zn0J9D/RmwlbwgpG7lSNN0W9f1Rq/725oKnwS9xWLRfA+tXDx0hDx8UH3hzlbtYrPzpGK3Wq2aMXYa7GKBSz5U5ANGP2RsiEvTtK0kmArd3IY9E+pssIuGu5GJFLFxdkOTJaITIQbGzQ2GOhdMkOgLcrcJZBPauZ3HmLKQbucb44sZh89hariLPkYs6PXdHt42EgCnjPdrK3zhOL7IeL5wDF8n9PkANxT2dsHlTsiT0GSDnxxVVW3N1wtfVWvGyunz82PonBlfl5lKeRvs6rpeJEmyMNfbkGd+Dmozg1hDZhPukiTZ2LPM3aiqaqNhb7fbbefzedvOtWP3aOXiISHk4YOYEu60atfsqp+mqc7Ok5l5fgJFOIA7t8FOz+ZDxFYN7IfL3AS6eRDsRit3YbizFbsDZsAOhroJFTp3aFVuyhg7vXBIIBsIeL2PP9GkJxG2Z0eea+dbhx5rqGJ4k+pfpO1rb9ur8k0JfmGVb0LY6wQ9c2w1+Gng8wHLXtcKX2nW/uuEPP+zYX+BasKdhDw5/G0a/mbml6DE/701uOqfv9Vg55y7lsty1sBnvtZU93z7llYuHixCHt6rqeHOHlK122630Tasbb/KB4UNdmOHr9bNbbDrq+DpmDszdmhmWrGdxYw13PWMq+ttvx5QnXMHVujcUGCbGMoOfq84tFJ3W9OzZfdpTvh7DI3pi47/G6r4uQnBryfwTV2jL7rIsoY+G/TMmL29il4Y+DQ4hUFPZ/f6HTr075eYn4s8UsGzx9z/7OnPVWJCXmXbxRrmnHNNuNNDbquqqr1s7kcrFw8aIQ/vTRjwhsKdVO02m02ma2rZgFWWpQzazsNAZ6sFYWvIVPHs1/K+gOc/cPK+ip0JddFqXTC2blLrdSTUuZ7b3MSxb3v3t+4ykB1QyXsnDqnkTfi7xG4efPyhsYLO7Vf6zG11eHlita/um70bGcvXW+HzQaqYGvSC1q0GS/27J3YZIVOxCwPewvwMaiVvL+SZIGoD3LWv4l3bwBdW+Gjl4iEj5OGdu0m4k2AngUoO24aVD4RYpc60fhbh9bqu94JfLOSFLVmzeHE4zq6zxZjd2H/CjFfbenXh5bGxcpGvWd0S07TN43kPmGBKcOybtbt3434LONb+7av4dcLfWOjT4BdupRaO34usrxe2crc9l/V+eyHP/DIU/rzacGdbtX0hrzTPRSdabMJg13fQysVDxhs83ikfbNrWrG5UHrZkNdzZypmEO6naabjTQ4bnhYO39bI5z01bKNa6jY25i86O7VmYOAkrdzecGKHGJj24qWPkCG4f1lAgvMEYwLDl2xv+BiZ22MpUbWftjizHstfKjRx2fb7K/J0S83Njf87mwc9kHky62At5sckXJuhFw55U99I0lfOaVi4eMj4M8E70Ve9kKZQ8z9Msy9LjkxMNTjM/mSLXduxc9k+q6+aDoCiKJthFglx7ds4dBaEuVsHbq9wF69uF4a5vQeJkYrBzB0yGUKNBjhD3cesLgVPG+rlI+ItcHwt8sbF8YYWvCKp8sQpfEYQ8fdzE/BKUmQp5bsbBdpYwiky6UFWkmrfzEzC0dXwdG6fnw96aVi4eMj4scOds9S7Wml0ul9l6vc5kQoWErPV6LTuJ5Tbc2WBnAtyRXre39YzxCcNdbtpC4QfLWLDrnSxh260m2E6eCEGQgzUhAB4y0aN3XN/IBI5o4IvsoKEt3tKEPFvJ0/Uf2wXDY2Neg0lLqfnFyIXVvEh1UZdU6VT2NPj5Sh6tXDxYfJDgzvRV7+SN2+8pm9kxd1K5k3BXFEXbjq2qajGbzY7krGFu5IgFvL3KXWQiRV8rNrq8yUj71Y1NinA3n9UKRMPfWOVvZDbvUOiLbbvWN3GjDFq1NuS1LVszaanzy1UY8IIquD5fu1TMXivZV/U6a+jRygX+5wcRuDUNeD//5a/bsXd/+5O/S6V6d3Jykn37+nV6tFy2Y+60aichbLfb6Ti7TqCr63qZJMlSL/vqnf26tGuPwrZsuGtFZLzd3qzYcDbslDF1LjJBQi8Q6PA+TF3eZcLCzXuhz87WDdbfCxdhrgZCnl0vr2/JoTSs4kWea+d52NnBOis4EvbsBA1auXiQ+ODBrcXaszr2zlbv/H6xTfVOq3Y23GmoC8/OOT1sCFyEq+bftGrX14YdmSjh+lquBDp8SAPBr7fa1zOLN1bhq4OWbhXczz5+Yvdd1rUjY8sNyf3sz1vwNMPn0wmbwbjB3cAEjQ/ayrVhz9HKxXvChxFuJRbw9M1bx97ZtbLMsVex89W64zRNj/XylIAXrm8XW6w4GGuXBK2hZif0gVasI9DhYzYl+A0t1zK0ILMNeMESKjboJbFfqoL9l12kkud6qo176wCasYOx5V8+ilYuYQ93jQ8o3FhfwJP27Gq1anapkLC1XC5lIoVMrFhkWdZU7tI0XVZVtTRhrj2SJDkOAp4NeeFCx0Mt2b5gF27s72Jj7ByhDp+osdAXWbB5b/JGsEZfeP8kqMwNLi809lnUsytIdLeP+9DKbSp7u12prdzr9bqsqqo6PjlpnreGPanuff7Fl4Q9vDN8YOFGwoB3cXEp73Tpn/74R10aRZZFkbkVsjvFQgKerdwFoe5EznVdn5iAF1bxOhMrgu3HooO4IzNk92bDDi067Ah1eCB6Qt9olS+o+O1V8lx/hbx3aaFQTwCNjiEMJmjcq1ZuPp/vjd3TcXuxyh5BD3dhxr8iDjUU8D57+rRZKmG73Uq+m2vAk6qdVO+0UucD3YmcnXMnNuzZgBeZXNEEu3CmXri1WF/FzgY7PU3cTQL4ZIWvex/W2p8T8+VEvywhRG8P1/GzE5PMfTpVcl/Nm/Szp8/HPJfETvTwj5WaVm7mW7kz08qdm/12o61cbefGAp5t5aZp2rRyTShsvlcqfFrdk8fXVu5sNmtbuYvFotRxe0+fPWvC3sXFZfN3kbD3s1/8yvkQmxD0cFt8oOEgdhatbdFerVaZBLw3l5ez5fGxLmLcVO8k4PmxdidBuHvkg11z1HWtrdqwgheud7c3S7Zvn1g3oWJHsAP6RRZidkOLNVt3sM9yR2xf4PvcyrXVPTnLny+HDXtXq1VZlmUzZk+ep1b1qOjhLvDhhoPI++lYwNtsNs3EiizLlr6C14Y6e/iA90greaaCF46/C7ce25slO7LrhCPYAbc3Yb2+qLseBjGyA8gHbeXqhA2dpKGBT8Kkhj2p7hVFsZvP5+Xl5WXx5MmTar1et+1cgh7uCh90mCzYhza1kyzm87nsMdsGvDzPm9BWVVUn3NV1fZokyakJd48iAW8RBDzbmh2aJTs4zodgB9y9ob163Xv4uevb9cMEo+pdz8qV0Ber8Pnxehr8mrCX5/lWSOCbzWY7CXvy58rkjKPlkqCHO8WHHiaxAU8WOj49PUufPnuWXa/X2dFy2ax7N5vNFpvNpgl4RVEcZ1n2qKoqqdidmnCnx6O+gOfH383N/rKZ2bzcLprau1esItgBD8M9aOWufbVvHbZ2ZSyfnMuyvPbXN6ZiuJXpuY8ePSrOv/++iAW9f/7Hv68JebgJJl5gMp1o8fz58/TVy5dN2Hr85Mmsqqpcdq2QMXjSopXQJgFPgp0Eurquz5xzZz7cnZmAp23adgcLPzh67hc0blqz4b6WwSbm7TyKm47zAfDxM2vztcu4+Ntq//5QmwkNadDKzcwkjdKvuVn4Xza1lXtkwt4yFvZMwFv7tq68r639ITv7SMdDh5ykZVkmWZa5PM9dVVXuaLlsgujlxUX95YsXyW++/lqWWNHJLEzEwMEIeRhlqnjOj8OTNyZ5k5y9efNmJtNofWv1yK99J5MstIJ3liTJYx/uNOg98mP0jnXbMqng2epdZIeKvQkV5k3dOcIdgP3lW97FrNyFD35h2Lv2HYkm5Dnnruq6brsTulh7JuuqlGXzXpbneVJVVV2WZT2bzerddls9Oj2tT374w2Ydvc+/+FKfL3AjhDxMYtq0ydNnz5q18HbbbZbP503Ak2VS8jxvAp6EOG3T+oBnQ55OutBdLewEi3bsnd0OKbYqvvPhzi7RAABWUN3TsJeYVm5mFndO/eSMVAOffz8qfWehDX0S8vySTtq+PQpat7ojz8JstdisBKC/NMufKwFPHj/LsqooCllLT/7MarVaJZcXF4lU887OThP5BZuwh5tI+VfDEH1DEvJb5ZcvXjShS/ajPT45mek+tNKWkCqezJjVKp4Jds0h7Vvfwm0reWYsXrvIsQY9GYunEyvsendmvVXSHYBR/pfB5r3DH52t1XQZJv+eM9MZ/f79SNfobIaVmAXbdeLYqRmKou917XuenHWymVkL9Mi+7+l73mw2a5eEOj07S/79t791v/n66/avZ9YaBCahkodRtoonb4oS8DabTVYURRPyqqpamIWOT4JZtO3hr2ubVtsYdluyzFTw2lBn27JU7gDc1CGtXBMAK1+FK/344NJX+Ypg5r/+YtqOIzZ/Xjur11cBpQIoe9/maZralQPS7XYr77HJbDZr3v+ePnvWPC+7yDQwFZU89AqreP7NJr28vEz9b506q7bdrky2Z/QLHre/4dZ13Zlo4cepHAWLHM/swsbmDZLKHYA7F1T39BfK1HQPMt/O1fDW7Obj36/m5tC27ML/8noUrPXZLgmllUE5+1UDZOJaO7GsKIpkt9slm80m+e9vvuE/HbdGyMMoP6O2XRtv/nbcyKwsS/ktVLYsW/gByMdmgeM22JkWhYzZO/JvhLZNEe43225oHqx7BwB3Kmzlml8oEzNUJPWBT3fZycIqnoZA05nobL0YWSmg+UU2TdPm/S3LMt7ncOcIeRgkrVoZE/L69evkarVq3uzyPG/e4LIs099KJegdadAz41WOw3Xw/NiWtnqny6TYNz0b7gh4AN4HG/aCGfyddThtCAwmg+29X9WeXvX7/bZHs4bL28kXTmbY6vdtNhv6srgTjMnDKGnVPn78OFkul+l6vU53u50sASC/lUolrxmULBU6P1t2afafbWbQ+rWidImUzhp4fvkCW71rng7hDsB9EVtUWdfY8ztnVGaNvUKXW/FbphVmN43OITN25RAyw1YeJ8/zerFYyHgYt1qt2n8BxuPhJqjkIUrH42mr9vz8PFmv100lT2aAyS8IfmFPmTihywU01Tw/5k4rdxrw2mVSfMBLYwGP6h2AD8UspNye/cSLOtwdQ/e9lYWSI/vd9u5t67c6k0WVZeJFE/5k6Ty7A8f599/LMir18+fP69//7pXdp5ekh4MQ8jBKpvGfnJy0Y/I2m00qC3r6MSi5P9p1oXTmbLBFWWf2mZlJG9tzFgDeG22r6vp1PuxVwazY0lTodibU6eLHzQLIzrlV7KjrWs5XsiuG3w2jCXtpmtoqX/Pnyc4Xjx8/bhZE/ulXX/FCwI3xoYooeb/7+S9/3Syd8vkXX2ZXq1X22dOn881msyjLculnz56lafpZXZzYs+EAACAASURBVNefJUnyzDn33Dn3zB9y++MkSWStKN3ZYmFm0to9aAl4AN67YL/b3uqdXz7F7mu78y3YTU/Q07D3pq7rN3K2R5Ikq6qqVmmarsuybLZCy7JsM5/Pd9vtdmcDnxz/8k//UPv3SSp5OAhj8jDJ8clJM61fpvi/nRCWdmaZ6SLGfmaZnV2WxcbfaTuYgAfgQzABrznr3rZ+nF0djrPze9nGqnjXvjIXBrzmSJLkja/iNeFO7yMBT753sVhsi6Jogt12u23atlLFk7F5Z2en9cuXrxiPhxujXYtBfu/ElizQKVP9q6pKzIzYdj0ps9/sTJcbMPdLI7PTAOC9GWrNSsXOHzpZoqnWSWs1SRKt1q18Ve7SOXdR1/V5kiTnzrnv/fHnuq7/bM7fy9eTJLk01TwJetez2WxTFMVmt9vtFotFuVwum5D36uXLSlq1L1++qqWK5xiPhxuikodRMrNWVmEvy7IJd1LR06AnazyZhUQT192torNzRbDkQIMqHoD3oa816wNerbNkx1qzdV1fm8AnFbyrsIInt+kYvLqur3QsXjAJQyp42zzPJeAV599/Xxz5kPf02bP6xYsvqeLh1gh5uBWzrpSl4+wGH3rKfQDgtoIlUA5tzUqw2/iJEtc+rNnWrIa7NtjZIxbu5JjNZjtp0+52u0IqeBrw5PABr/7nf/x7qni4Fdq1GHV+fl6v1+t6u93WRVHU8/ncyQKeaZpq20PfMPXQN846Rv88PyaPNy8A74RtzerVgdbs1rRm7UzZN77VeiFvh9qS9cd3dV1/J2c5kiT5sx5yvyzLLtI0vayq6jLLstVsNlsXRbHO87xp0y4Wi2Ys3nq93gt4tGlxF6jkYZCs0fT5F1927iIrs0vAk0MW8ZQ2h2lx6NHODAsCoL7R1rRqAbwLYWvWBL3btGaHKnd6vZmAUVVVU72rqmpTlmWzVIqQtqxU8NI0bd4nZ7NZeXR0JAsgN2PwbMBjNi3uApU8THK1Wskq7J21o6qqat8gw8MvEFpo8PPrTOkbbPubNdU8AHclnFShv1j6y6UPd3YXinaWrA9zV7rkSV3XF0mSSPXue51IodW7yPG9TrCoqupcqnfyOFK9k8fMsmwtS6Ro9W6z2TTvj6vVqjw/Py//37/9a/Oeqi1aAh7uCpU8DJKFOP/tX/+t/tH/+l+yxU4zrX+321WyQrsEt6qqdOX3nXnTbH8j9r8dN2HP/9ac+d0uKj/jVsf1UdkDcGM91bvYFmTtL6Z+27GtOTTsXfsJFWs/rq5ZzFgnVKRpemWu6xg9HXPXVAElzMmYO9nVoirLIp/Pm9mzaZpWYfVOnqNW7xwtWtwhPlQRpZnrf/+f/5teXFymr1+/bpZFyfN8cX19fZRl2UmapqdlWZ4lSfKZc+5pXdfP/KLIuhjykyRJHjvnZOFk2c/2SLc20wWR/Z/DrhcAbqQv3NnJFf4XzMpPqChNa3YbrnnX05qVkNeGPZ1QobtXyPelabqR9qw8XlmWuyzLmmqdLI2y2WzKq9VKRrdUp2dntR17J0+aCRZ4V6jkIUqLaz//5a+b3zJlcU6ZeCFvUn6fxUJ+Q9U3Sjv7TA9zXRdHzoJlVeTPSXWWLRU9AFPdYEmU0lfu5H1ra9+3/Fg6bddemWVRwi3J2iVR0jSVMXdrDXdVVW39sijSwWj2o9WAJ8/j+OSkkr1opTX7+Rdvl0eheod3jZCHUX7yRRP2FouFjskr/G+rnTdKv27U2lfttHI3j4U8E+4IegAmm7pbhZ1YYRY3bt+zJNiZ3Sra1qydWCHXNfT5gCfVu+uiKLR611kS5fj4uLy8vJRlUSqdNSvhTlqzsoOFvJdquPvnf/x7wh3eKT5I0SvWsl0sFnlVVfO6ro9kT9qyLE9kD1u/T23TtpVWrTk/9oe0bOW+uoft3G+Hlplxep3WrWOxZADGUGs2mNFfmrF3O9Oe3URas2sT6K7sYsa2Nau7VITr3fmjnXx2vV6Xz54/r2azWbNzhVnYmHF3eO+o5GGUHzeiLdtK2g+z2ayp5MkbnLQq5Ddiv3SAvEFKgFuY/Wxnwb617SLIQYbTXTL0dqp6AG60W4UJeFvfntWAp5Mkrsz4uzbg+XB35SdXRFuzsiyKjLmTyt1yuZRZssV8Pm+qdrvdrpRJanL58vKilpBHaxYfCkuooJf/Dbn5srRs5bdSmRkmIW+9XrchT974siyTN8Ers3aULCDaHP4NdGXeVHUG2ta3T3SmW2UWKq3tEissswI8TEFr1lbtSjtb1i/b1LRi7QQK/96je82emwWNv9elUGRBY13UWBcz1n1nZUHjoihkKZU3u92u2Xd2sVhc696zaZpu5/N5+z725YsX1e9/96qU6p22Zu2yKAQ8vE9USDDItmxfvnyVXF5cZD/4y7+crddrqdLNZ7PZUtu2dV2fymxaad06557IkSTJE3/5zH89bNsudGJGpHWbmtcoLVzgAblBa3YXWf9uaNZs73ZkfVuRha1ZXRJFWrN9Cxo7Knf4gKjkYZBW8+RNS6p5Mv1f3tRk1lgz/uT6eutXdL/2ywm02wD5rYB0O6BLX9V7Y1eHt1U9P2amCH5Dr+yCplT2gE9b34LGNtRpS9bM7rdBbuUXM+7biqx3OzJd0Fi+TxY0lscpy7J5v5ItyWQ7su1227xfXa1Wu2/+67/aBY3Pzk7bBY3tjhUEPHxIVEQwKqzmPX78ODs/P28nYex2u0WWZcvdbidr4T2S9fOkcuePJ37ixZk/n5pJGMcygSNJEp2Fm5s19HQmbhosu9JW9tzb50ZlD/hEDM2aNUFPd9AJF2LfBEs5rSdsR9ZW7uSXThl2orNmddydzpq1a95p4LRLosjzpXqH+4YPR0zi18xLfv+7V8nf/uTvmpm21+t1drRc5j6gHZVluUySpAl6vi3bBD2/ILINeafBbFu73Io8Xu5bt7pgsk7aIOwBn6BbtGY7u1UMLWisixmHLVsJd1oJ1HAnj6eLGe+2253drYLWLD4mfChiEq3m/ewXv9IZsOnJyUlWFMVss9k0Qa8sy6ai53e3kBD3SMbhmbCn1T0NeboTxjJYWmUeLKCcSdDz26CNhj3HuD3go9A3a1a2ITMVvM6sWbMcSrskioQ0v5jxYOVOQ56ujSczZmPhTqp3snBymqYFu1XgY8YHISbTat6LF18m0raVsHW1WmXZbDaT1q2ciqJYaEUvTdMTX9U7lbCngU+um5B34oOebnu2MGEvbN9mfZW9oJLHJA3gntNxdxru+lqzvj3b25od260iCHntene6JIqEu/l8vhVavaM1i08FH4CYTN6D5b4a9GSB5N1ul8r4PAliu90ulzXyFovF0Xa7PfKt22Pfun2k4c7PsrUt2xNT0TsyYa9t38bCnh2vpwspmwWVHdU94P45sDVbmKOvNdtZ704XNZazX+uuU73T75P17iTk6Zg74eq6oDWLTwkfejiIbdvq+LxXL1+mp2dnnaAnVT1p3UpVz0+wOEmS5CQIezbk6fi840jQ6wt7abBVWqeN21fdcwQ+4L3rCXfujluz7dg7W73TiRXampWAJ2HRb83YmVRBaxafEj7ocLAw6J2enqV5nqd+/bzMBj0T2I7DsCeX0zRtzqZla8fohe3bsIXbW9mz1b2xwOcIfcA7M7BbhW3NlmbmrLRl7V6zk1uzGuykgqeLs/uF2tc23Mkh1Tv5s/I8L2nN4lPFBxtuJJyI8d233yZPnz3TsDXL8zyXsKfj9CSwVVWls2+1jXtiQt9x0LZdRtq3i2AG7ky3TYtU9vrauHuBz5mWriPwAXemrzWrkyt8W7Yy+8wWI7NmO61ZO+YunDkbzprVx9P2rGxDdnl5WTx58qRar9elhjtas/iU8GGGG9HxeWHQk4qetm7lKIqiqeplWdZW9dI0XUrgC6p3saMv6EXH65kdM9rZuGZG7pTA56jyAbc3NO5OW7O+LVv5yl1pWrNbs2NF75Iofa1ZnVgxtlvF9XpdPnv+vBl3J1s2yh6zhDt8amb8j+Im/Bu2hqT6Z7/4lWzGLa1bd3lx4U7Pztxms5FpsPVsPq9ljEuWZfIbe1FVlW4cLm/qzV6T8pu2WbVe39RjQa+vhZv7il4s7HXG7dmgp2HP/xMktZYo/XVnPrAUoQ+IG2jNVn7XmnDcXamtWXkv0L1nD2nN+kkWV75N22nN6oLGUrlbLpeyO0UhFTx5DrvdrlytVs1zu7y8qCXkvXz5itYsPil8WOFWwoqeTsaQWbd/+uMf0+OTk05V7+joaF7XdbOmXlVVTXVPdrxIkkT2wF3q2bdzl0HrdkpVLzpmz1b2bHVvYLJGrMrnYu1dR/DDPXbbLQCnvrYP2a3CzJzVcXdbu1uFmQk7uTV7090qfvrVV47qHT5VfDDh1mJB7/MvvmwXTfY7YzRhbzab5RL2yrJsFlCWNq4Ne/7chj0NfibghUHvyFT0ojNxze4ZsXF7e2Gvp53bt/YeoQ/3RqTqrBdvElpGx6vaP++A3SpsJb+dNRtU8dcm0DUhT5dFuUlrliVR8FDxQYQ7Yydj2AWT9VgsFtlms2krexr05JBxe2maNqGtruuFD3ZH/vrSXA9bt31VvdiyK3utXH+5fY7+7zB50kZsTJ9eIPjhXYlV5/oCXU8Ldcyk8apuP9wNLoliAt7Wt2c14K17JlZcTZ01a6t30gLW1uzQkiga8Ah3+FTxoYM7FQt6z58/T6R9WxRF+u3r16lU9XbbbeaSpJmF6wNYW4mTyp4EPgl7NszZ4Dch6IVVvXY2bjAjN1yCpTN+Lxb67HZq4eLLQ9U+Fwl+kfsCHbcNdD07S+x9bxjsRiYodf5M83hTdqvYBtW7ta3e9W1FdhetWZZEwUPDhwvuXNi+tVW9y4uLJMuyZqxerLKXZVlb3ZOgVxTF3I/ZW5jKXhj+FpGgF07MmGvQS5Kkr5WbjbV0zQdf2hP2DtlibTD89XwPPkF94+bC7mjnykigM2Pi9Ot1LPAFrzP7S0zvTjKRgDS2JEos3MVmze6FPD3sbhWx1uxuu92xWwXQxQcI3pmwqvebr792Minj9evXnTaubBl5cnIiu2VksbCnh2/j2pbu3uVIyOuEvbqucx/y+lq5nckapp0b7qzRqfLFxvMFs3YP3X2DAPiJuUmQcwPtVhviYoHOHtpCjXyPPpYLXrfh6zsNg14QFPcC3oTdKvaWRdElUcLKnQa8vtZsmqYFu1UA+/iQwDvVV9WTFq4Ne1LVu7y8TG3Ys5M08jyXNm4u1b2yLOc+1LXBr+8cBj0f8mKzcWOzcjs7akgI9DNze8fxxSZw9FX5zL9NdNzTQIgbDYDtHQmC78XYDNaxIOfGw5xz+xv5u6FAF1yuwq9FKoP6Ok6D1/feepPm79VOsAgnVoS7VYSTKqZU7mjNArfDBwDeOfuh8PNf/rq5rGFPFlD+8sWL9Pz8POkLe3JIZU/Cng96eVjh85M3FkHFz34tnIEbBr2+wNeGPTtpY6CtO9bavU2L95D9dycHwc43EQobhyw7MiXAhY8ZC3Lh7bFKXd85Euhih/1aHfz5Lgh4e69zX9m2r2Ub8Kpg7F1st4pJlbvYbhUS7uTxdJ9ZWrPANLyh472J7JIxGvbm87nshdu0UXWxYwl8EvQk8Mkxm82aKp+ZqSvLsnQCnQl9eRD48p4xe7lv4cYma4Rj+DqBL6h8TA19fWv09c5ynLKG34TQ1jeY/kH+YAz8cw3+g0QC3N73xCY8RMbQ7V2eWKWLHrqrhNkbtgqCXvu0IwEvukd00LatzCQLadE24c7PnB3arWJvYoW2ZWXGbCzc0ZoFDkfIw3t3SNjTwPfm8jLN53Mds9ep8NnAp1U+CXNmAkfnul4Obo9V9WKLK4dHNlDl29tLd8p4vpE275SqXyfsHTLm74BK3sf63jHpQ78ntEW/P6jCtfeZODHCXo5t/6VH2G7dC3U20AXhLjyGQl5mxqjaSUp5EPT036YOWrTbcNZsbLeKIOS1693pkigS7ubz+VZo9Y7WLHA4Qh4+mKGwF47Zs4dU9vI8z4qi0IkSszD0FUUxs4FPPqzkbIOdmYQxDyZkhGvsDY3d6xvDZydu7O24MVDpGwx+Eyp/bqj653pm+U4MejdqAd8nh4yNc5G2qusJb87tV+rGKnMDgS5ciqSvWleac3i5sMHO7A+r4U8PZX8p0Yp2304y+hqtTbgsIvvN2vZru5ixrHWnAc9OqvAhr9niUMfcCVfXBa1Z4GYIefjgpoQ9WXrlr374w7SqqubQVq584EjYOzo6km3TwhbTLAh8Mxv4+s4aBP312cCYvVjg64S9iRW+2O4bNuz1TuYYW7svmNwxWPUb2sljrBr4kZhchXPdkOZcT3VuYCsv1xfm+qp0kTFzfaGur0Jnw10RLGPSCXp+HJ0+F/uamwVDGOxhX+OJeY6lnUEbmVwRrd7pxAo7a1aCYlmWO63eaeWO1ixwM4Q83BtDYc8/x/Tx48eJbeXGKnzSzhVm/b1OxU8Dn4S4qqqas72sAS92W0/IGwx74bZqJvh1xvENzNodW5w5uv/uIe3esesuMgnkI/3JmTLZYdL1gXarc0FVbmCChH59rw0bVN3CSt1YqNu7Hqnm6fMLW7U24IXrTebm9eb8cypMyNsbgzdltwqdqCHVO3meeZ6XtGaB2yPk4d6xYU/YdfZkT9ywurdarTqhT4Le1dVVc57NZk1bV4LefD5vx/NVVZWFFT8zwaIJd3rZhj2tBurXRlq44dp7QxM29mbrhi3eYPZjEjnbal90cocbmdVr3hM6lyP3a9331m2kCBkNdMGM0zp2v0OWLxlrveriwcEac9FQZ7YG6wt4sWC3iwQ9fZzKBNPELA00M5OTYguL20qeMyEvHIsXLnAcnTWr4U7bs7IN2eXlZfHkyZNqvV6XGu5ozQI3Q8jDvRWsxxWt7slEjafPnjUfUlerVfLs+fN0vV4nNvDJeb1epxL4NPQJCXxy5Hm+F/oGQlsnDMZuNzNxbcgbCnp9y7IMLdPSW+0bavP621ykzdup9g0EQxebxesOm7TxXoxt1j8U2IbG0Pn7VxParr1VuoGxdUNVu7HKXaHLmISH7h0rIU8OGdsW/Ps0IS8Yp6pLEemRmwkY+o9pJ11ch+PxfDt2dLcKPa7X6/LZ8+fNuLtXL19WT589I9wBtzDjHw/3lX0j94Gv/eDVwPeTv/uJjt2rXzuXzOdzqQAkJvDJh4cEvNSP39OqmAS8VMKejpnT4CeBT1Zi1uCnZw1raZp2gp9W/YIw2AQ8ve9ARS+2w0ZflW8v8EUWrw3H9KU+f00e19f39TDo2d0S9Hxfgt7Y7Ngp686NjacLW659Y+qCCt3Q+Lqxyt1euJP7VFU1GOw03Olt5vnUaZq6qmrmXzSvLf8a1WWH5sGi4raSl5q/Y7M2nix6LAFOx9n5YNe7W4VU7pbLZbFarQqp4Mlj7Xa7crVaNY97eXlRS8h7+fIVrVnghqjk4aMyVN0L27k6fu/k5CTRlu5ms0nOzs6aVqi2Q+V8fX3dVPrkuo7ps6EvTdO98Od3wGhCn162t/tg2Lmvr5Z0LgfBrre617PN2tCRRCp+QxW+sIIXu1905u49fw1FZ8COVOKi4+lGljMZqtZ1wl1k/bq+iRQ28HXCWhjy+kKdbdNWVdX8eWmaSsCrq6qSo/m/lte4VqjNDPRFOPnCv24TCYjyWPLna8gzO1u0R2wrsrHdKn761VeO6h1we4Q8fLSmBr5//+1vnbR0ZQzf6dlZErZ1t9utfOynzlfFtDqmoU/C3na7TW3w09BnA6APfHshTkOgCXRa2cuGzmacVG8rNzZhY8KM3dgEjlibNwx5adDSvVfVuz7hLFm9Hhk/F1blBrcImxruBiZQdCp3vurXhrrwHIyp61zWsGe/T26XUJemaenDWCm/oxRF0bSQ5/N58w+y3W7tbhd2jGp0dq1/zYZj8nRcniyELIGuHXMX7lahB0uiAO8eIQ+fhL7A54IxfH1Vvuv1OjlaLvdC3/HxcVvp0w9CP3O3E/5M0Ett8NPQFwt0NsyFX7O3ySHLxtjbXbCH7k3D3kCwG5zcof/UH9lrJzb+LtZujQa+W4a7ygY5ve7HxpXBhIhoyOs7a5Cz57cF50qWHSllCIOc9XnMZrO6KIq6LMvm30NGLJRlmZjX9ixcYFzHnMovLP612IY8UzXcBWPtmmAnS6LobhXamh1aEkUDHuEOuD1CHj45Y4FPq3zOTNyYEvry+TwZClE29OltGvwk7MkhYwJ9WywNA50NbkNf09AXBr0Djqmhru9r7iMMenXkPDaebuw8+dCAp6GuL/TZy7ayp5dtgAsv++pcJ9CFhwS89XotlbM2QOV5nux2u/b/PNxRJhh/qq/nRFq90vK11byqqnZpmu7sWnfsVgF8OIQ8fNLCwOf8kix629TQt1wuE2nv6pg+Obu3a/M15+VyKZM6RkOgVNx08ocZB9Ve1w9RqRraAGeD3S3CXWqWy0iGrtv79IzX+yjH5MWWPTGVNjtZora39V2/adgLA59+TZdV0RarHjqWTkNd+Lg22MnLzH5NAt3ValXl83m9WCzqzWbTHPoPslgsEjn0NS0z0mXNSQl7i8WiXWRcXr+73a6ZxFQURfO9GvLKtwNZ92b7StVuu92yWwXwgRDy8GDYwOduEPr+4w9/cDqm7/jkpKn2PX7ypAl8Uu2b+0qfBD9p8wbVEfkgbVur2h67q8OGMxMg926Phbww4IXfZ+8jZ5mNGe6ocd/ZHSlkwoCGNTOpog131dvppp1gNxby7PeFt98kDI4dUpHbbDbtWntyPRboLi4uKjlfr9f10XIpX6v/4gc/cH4Ga0N+kfnvb75x8pq2rxVdXFzGpm42GztMQV7vzfdKoNQ/uygKqSyWctZwJ0ui+L4xu1UAHwAhDw/WTUKf2VPX9VX7tCqi5912K6GwCX1yaNVPDqnYSfjTKqAZG9UJiGYySKqzIX3lLzGhrnO7fI8NbH5GZHMeuhwGPXvfMOS5jyDoBUvxtCFPg5kGsTDg2a/3XbbfJ4HLtC+bm0zVrnNZJj/40NipvPlxcnu3yf00TO12u9q3W6vddltLoJPLUp0LA93xyUnzd3/8+HF9fn7eXP7u22/rv/nxjzv/Rnacqk5M0sqxnYkur195rc5ms+b/XMf3haFUw53/82nNAh8IIQ/wbhr6dPauXNcZvLY6MhT+ZJyfrfyZD9Am3GnYCy/P5/M2ENqvSfbQsCeXNRSaZTISex+9bm8Lq3s24Om/UeTf6l6+l0QWRG4rR7GgZ6t2OuZMlxqxt+l1/bqENg1ydqyaBDQNbHLebrdtgLNfs5clNEl4aqpyV1dNdU7DnLZb9bxcLmWMXRvoLi8u6r/+0Y+cBDoNc9Ialb/z73/3qpalSWL6lh+S10BPxbqx3W7r09NTpxVDeT7Slv3PP/2pqdyxWwXwYRHygB5TQp/rCX7OV0ecr/hpq3co/Lm3H5rNh6gNgDowXs6+mteEQQ139qzhb+hrNujFzmFQtPeTQ8Zj+a9/dCSAzWYz59eHawNbGNDs7bGzDWwa0PQ89DVb+dKKXHv2QU6C0/xtdc7Fwpy2W6cGOm2NKgla4f9bbPkhHapgf3Hx60122OekFUPCHXA/EPKAA8Qmcrie4OdMhcSNhD/39sMy8eOinM7ulQB4cXERDo53YQjUICgB8Pr62mkQlHMY+OS2zWbj7G1mGQ1nA6G93YS/NuTpAPz7ToKd/zvUevbBztkQZipt7e02qC0WC6fLj9jv0+qbnI+Ojpr7aIALQ5wz4U2Os7MzJ2dts/rXQttqtWHOv45q/zqaHOim7C8c/hITLj1kK9YhGzL1+YRLojgCHvDeEfKAW4iNRxuq+OllG/5c5EM0DIDB4HhnlnhxNvzZy1IRlMqgXDaVwM5lGwo1GDof9GwI1NucX1ftY37NmPXhar1uA5szY81saHNv/+10PFzn8txX4JwJcOHlMMTZCRBhkAsrc+6A6lxkT+HJwUpfz7Glh1zkddv3vMJwSbgDPgxCHnDH+iYi9IU/F3yIilgAFDYEytmPm2qEQVDawX/+7jtnw6BWBfX65eWl0zFWcl69eeP8eoCdMCjnq6srp9c/dhLQjo+Pm7MLw9t2W588euQ0tOm4Mw1rtvrmfHj77OlTJ+1UFwlw/v+r9v9fbYiTcyzIybkvzLmR6txdhamxpYdiYs+LcAd8WIQ84D0ZC39uJAC6gRAo5zAIOhMGbVXQmUAobCiU81AwVOH1j4VdH84NBDZhQ5ucw+Cm1TdnwpsLApwzbVUXCXFuJMi5gVbr+wpQh86eJtgB9wchD/jAhj5Ew0mrfdWUsSCoNBA6HwrDMVY2FIowGOplDYgfGwlqKgxsco6FNhdZdsQGNzU1wLnI5IehMXOEJgA3RcgD7rmxSspYJTAUC4SuJxS6SDD8FIwFNmdCm5sY3KwplThFiAPwrhDygE/AlJZa31J2hwbDT8mhgc2aOGOVAAfggyHkAQ/MIWOs7ukax3duSmBTBDcAHwtCHoBRH8setYcisAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAODBAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPDgAQAAAAAAAAAAAAAAAAAAek/+DgAAAOJJREFUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHjwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADx4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB48AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8eAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAcPAAAAAAAAAAAAAAAAAAAAAAAAAAAAeECcc/8fZ8Qu105QtY4AAAAASUVORK5CYII="
								id="image751"
							/>
						</g>
						<path
							className="cls-40"
							id="polygon755"
							d="m305.11 207.94 2.41-1.39v12.01l-2.41 3.55z"
						/>
						<path
							className="cls-13"
							id="polygon757"
							d="m305.3 207.83 2.41-1.39v11.86l-2.41 3.55z"
						/>
						<path
							className="cls-5"
							id="polygon759"
							d="m282.6 207.81 4.74 2.74v.28l-4.74-2.74z"
						/>
						<path
							className="cls-5"
							id="polygon761"
							d="m282.6 208.52 4.74 2.74v.28l-4.74-2.74z"
						/>
						<path
							className="cls-5"
							id="polygon763"
							d="m282.6 209.16 4.74 2.74v.28l-4.74-2.74z"
						/>
						<path
							className="cls-5"
							id="polygon765"
							d="m282.6 212.55 4.74 2.74v.46l-4.74-2.74z"
						/>
						<path
							className="cls-34"
							id="polygon767"
							d="m283.85 212.69-.62-1.61-.63.89z"
						/>
						<path
							className="cls-34"
							id="polygon769"
							d="m287.34 214.71-.62-1.62-.63.89z"
						/>
						<path
							className="cls-34"
							id="polygon771"
							d="m285.6 213.7-.63-1.62-.63.89z"
						/>
						<path
							className="cls-20"
							d="M284.14 231.77c2.56 1.05 5.22-1.81 3.03-3.58-3.09-2.5-6.31-4.97-6.02-7.26.29-2.29-5.4-3.08-5.4-3.08-1.65 2.37-2.73 3.48-3.01 4.94-.33 1.77 8.39 7.74 11.4 8.98"
							id="path773"
						/>
						<path
							className="cls-20"
							d="M301.24 220.74c-.07.99-.98 5.78-.79 6.65.19.86 16.87 1.93 18.31.93.99-.68 1.91-5.09-2.02-4.9-3.94.19-7.85-.86-8.42-2.68-.57-1.81-7.07 0-7.07 0z"
							id="path775"
						/>
						<path
							className="cls-29"
							d="M284.35 231.04c2.37 1.43 5.51-1.93 3.32-3.7-3.09-2.5-6.3-4.97-6.02-7.26.29-2.29-5.4-3.08-5.4-3.08-1.65 2.37-3.11 3.73-3.11 5.22 0 1.49 8.42 7.14 11.2 8.83"
							id="path777"
						/>
						<path
							className="cls-29"
							d="M301.24 220.17c-.07.99-.96 5.35-.76 6.21.19.86 17.73 2.01 18.66 1.24.93-.77 1.54-4.97-2.4-4.78-3.94.19-7.85-.86-8.42-2.68-.57-1.81-7.07 0-7.07 0z"
							id="path779"
						/>
						<path
							className="cls-29"
							d="M301.07 132.19c.66-.04 7.38.6 9.94 5.13 2.56 4.54 4.18 7.72 4.18 7.72h-10.31l-3.8-12.85z"
							id="path781"
						/>
						<path
							className="cls-39"
							d="M296.31 173.64c-.16 3.06-1.4 26.03-1.4 27.95 0 2.72-10.34 19.34-11.29 20.45-.95 1.11-8.08-3.17-8.24-4.12-.16-.95 8.55-14.49 9.34-19.19.33-1.98-1.26-9.53-1.44-15.26-.19-6.47-1-14.04-1-14.04l14.03 4.22z"
							id="path783"
						/>
						<path
							d="M303.71 167.29c.64 2.19 6.97 26.54 6.89 29.42-.08 2.88.24 23.8-1.35 24.44-1.58.63-6.5.31-8.08 0-1.59-.32-.57-21.5-.57-21.5l-6.72-26.76z"
							id="path785"
							style={{
								fill: '#606463',
							}}
						/>
						<path
							d="M282.67 178.45s-.03 3.31 0 4.62c.03 1.3 12.01-.9 16.2-3 4.19-2.1 10.11-4.48 10.11-4.48l-5.02-5.84-21.29 8.71z"
							id="path787"
							style={{
								fill: '#949997',
							}}
						/>
						<path
							className="cls-39"
							d="M310.29 146.72c-.61-1.69-5.17-14.53-8.66-14.54-4.3 0-10.25.29-12.58 1.59-7.63 4.26-8.74 7.73-9.49 8.72-.75 1 3.4 36.17 3.13 37.36-.44 1.94 21.1-4.13 21.04-6.12-.07-1.99 7.45-24.58 6.56-27.01z"
							id="path789"
						/>
						<path
							className="cls-16"
							d="M299.41 132.13c-.07-.12-3.54-.18-6.09.05-2.99.26-7.18 2.76-7.78 3.79-.6 1.03 9.08 10.92 12.32 10.04 2.57-.7 2.36-12.46 1.55-13.88z"
							id="path791"
						/>
						<path
							d="M297.86 132.26s-2.58.55-4.18.69c-1.87.17-5.25.46-5.63 1.1-.37.65 2.78 8.35 7.49 6.86 5.29-1.68 2.82-7.76 2.31-8.65z"
							id="path793"
							style={{
								fill: '#e9e8e8',
							}}
						/>
						<g id="g875">
							<g id="g801">
								<path
									id="polygon795"
									style={{
										fill: '#f9c36b',
									}}
									d="m319.16 128.22-25.51 14.73 19.57 11.3 25.51-14.73z"
								/>
								<path
									id="polygon797"
									style={{
										fill: '#d4a65c',
									}}
									d="m307.71 134.84-3 1.73 19.57 11.3 2.99-1.73z"
								/>
								<path
									id="polygon799"
									style={{
										fill: '#d4b284',
									}}
									d="m307.91 134.72-3 1.73 19.57 11.3 2.99-1.73z"
								/>
							</g>
							<g id="g851">
								<path
									id="polygon803"
									style={{
										fill: '#f6b545',
									}}
									d="m313.22 154.24 25.52-14.72v29.45l-25.52 14.73z"
								/>
								<path
									className="cls-40"
									id="polygon805"
									d="m324.25 147.88 2.99-1.73v14.92l-2.99 4.4z"
								/>
								<g id="g847">
									<g id="g819">
										<path
											className="cls-5"
											d="m319.14 172.49-4.33 2.5v5.99l4.33-2.5v-5.98zm-4.04 2.67 3.75-2.17v5.31l-3.75 2.17z"
											id="path807"
										/>
										<g id="g817">
											<g id="g813">
												<path
													className="cls-5"
													id="polygon809"
													d="M316.14 177.38v1.42l.18-.1v-1.43l.42-.25-.52-1.93-.51 2.53z"
												/>
												<path
													className="cls-5"
													id="polygon811"
													d="m317.21 176.76.43-.25v1.42l.17-.1v-1.42l.43-.25-.52-1.93z"
												/>
											</g>
											<path
												className="cls-5"
												id="polygon815"
												d="m315.71 179.34 2.53-1.47v.29l-2.53 1.47z"
											/>
										</g>
									</g>
									<g id="g835">
										<path
											className="cls-5"
											d="m324.48 169.41-4.33 2.5v5.99l4.33-2.5zm-4.04 2.67 3.75-2.16v5.31l-3.75 2.16z"
											id="path821"
										/>
										<g id="g833">
											<g id="g829">
												<path
													className="cls-5"
													id="polygon823"
													d="m322.55 175.39 1.15-.67v.29l-1.15.67z"
												/>
												<path
													className="cls-5"
													d="M323.13 174.06c-.34.2-.62-.01-.62-.47v-2.05l1.24-.72v2.05c0 .46-.28.98-.62 1.18z"
													id="path825"
												/>
												<path
													className="cls-5"
													id="polygon827"
													d="m322.98 173.81.3-.17v1.62l-.3.17z"
												/>
											</g>
											<path
												className="cls-5"
												d="m322.17 175.51-.43.25v-.83c.28-.28.47-.69.47-1.04v-2.27l-1.41.82v2.27c0 .35.19.54.47.5v.84l-.43.25v.5l1.33-.77v-.49zm-1.15.87.43-.25v-1.2l-.07.02c-.24.07-.4-.08-.4-.36v-2.06l1.06-.61v2.06c0 .28-.16.62-.4.83l-.07.06v1.2l.43-.25v.09l-.97.56v-.08z"
												id="path831"
											/>
										</g>
									</g>
									<g id="g845">
										<path
											className="cls-5"
											d="m329.82 166.32-4.33 2.5v5.98l4.33-2.5v-5.99zm-4.04 2.67 3.75-2.17v5.31l-3.75 2.16v-5.31z"
											id="path837"
										/>
										<g id="g843">
											<path
												className="cls-5"
												d="M327.3 173.11c-.17.1-.29.12-.38.06-.09-.06-.12-.21-.11-.43l.27-.12c0 .09 0 .2.04.24.03.02.09 0 .18-.04.09-.05.15-.11.18-.15.03-.05.04-.12.04-.22v-2.25l.27-.15v2.25c0 .18-.04.34-.12.48-.08.14-.2.26-.37.36z"
												id="path839"
											/>
											<path
												className="cls-5"
												d="M329.22 169.2c-.13-.85-.78-1.16-1.57-.71-.78.45-1.44 1.53-1.57 2.52z"
												id="path841"
											/>
										</g>
									</g>
								</g>
								<path
									className="cls-13"
									id="polygon849"
									d="m324.48 147.74 3-1.72v14.72l-3 4.41z"
								/>
							</g>
							<g id="g873">
								<path
									id="polygon853"
									style={{
										fill: '#c5923a',
									}}
									d="m293.66 142.95 19.57 11.3v29.46l-19.57-11.3z"
								/>
								<path
									className="cls-5"
									id="polygon855"
									d="m295.58 146.58 7.33 4.24v8.46l-7.33-4.23z"
								/>
								<path
									id="polygon857"
									style={{
										fill: '#eaeaea',
									}}
									d="m295.65 146.62 7.21 4.17v8.33l-7.21-4.16z"
								/>
								<path
									className="cls-5"
									id="polygon859"
									d="m296.31 147.72 5.89 3.4v.35l-5.89-3.4z"
								/>
								<path
									className="cls-5"
									id="polygon861"
									d="m296.31 148.61 5.89 3.39v.35l-5.89-3.4z"
								/>
								<path
									className="cls-5"
									id="polygon863"
									d="m296.31 149.39 5.89 3.4v.35l-5.89-3.4z"
								/>
								<path
									className="cls-5"
									id="polygon865"
									d="m296.31 153.6 5.89 3.4v.58l-5.89-3.4z"
								/>
								<path
									className="cls-34"
									id="polygon867"
									d="m297.87 153.78-.78-2.01-.78 1.11z"
								/>
								<path
									className="cls-34"
									id="polygon869"
									d="m302.2 156.28-.78-2.01-.78 1.11z"
								/>
								<path
									className="cls-34"
									id="polygon871"
									d="m300.03 155.03-.77-2.01-.78 1.11z"
								/>
							</g>
						</g>
						<path
							className="cls-18"
							d="M297.66 127.71c-.86 2.72-.03 7.07.09 8.02.24 1.85.29 3.64-2.3 4.43-3.32 1.02-5.49-3.63-6.08-4.87-.6-1.24-1.32-12.59-1.32-12.59l9.61 5.02z"
							id="path877"
						/>
						<path
							d="M302.73 113.47c.45 7.16.11 16.3-3.19 17.73-1.73.75-6.5.49-10.1-3.66-1.66-1.92-2.79-4.75-3.91-8.81-3.52-12.86 17.19-5.26 17.19-5.26z"
							id="path879"
							style={{
								fill: '#f7d4b2',
							}}
						/>
						<path
							className="cls-13"
							d="M294.1 118.06c0 .39-.21 3.5-.44 3.75s-1.96 1.21-2.21.65c-.11-.26-.86-1.79-1.9-.97-1.04.82.66 6.73.27 6.73s-4.32-6.01-4.28-8.24c.04-2.22 8.56-1.93 8.56-1.93z"
							id="path881"
						/>
						<path
							className="cls-16"
							d="M291.7 119.59s-3.39-9.18-2.64-9.48c.23-.09.68-.84 1.86-1.2 3.4-1.04 7.9-.14 9.64 1 3.58 2.37 3.74 8.96 2.33 8.78-1.4-.18-10.89 2.21-11.19.9z"
							id="path883"
						/>
						<path
							className="cls-8"
							d="M284.75 113.57c-1.68 3.55 1.07 7.56 1.07 7.56s6.43-.25 6.73-1.42c.16-.61-.56-2.97-1.1-5.54-.49-2.31-.21-5.35-.54-5.27-.68.17-4.61 1.38-6.16 4.66z"
							id="path885"
						/>
						<path
							className="cls-8"
							d="M303.32 115.02c2.04.54 8.17 3 7.56 3.67-4.03 4.44-19.65 2.24-19.43 1.71.27-.67 2.32-2.5 4.86-3.68 2.8-1.3 6.15-1.93 7.01-1.7z"
							id="path887"
						/>
						<path
							className="cls-16"
							d="M283.01 138.03c-1.12 1.05-3.93 2.25-5.84 8.17-1.91 5.92-2.12 16.94-2.41 21.09-.29 4.15 3.27 3.45 3.74 3.27.48-.18 1.73-3.48 2.96-4.24 2.63-1.64 4.04-11.15 4.07-16.93.02-4.01-1.46-12.37-2.53-11.36z"
							id="path889"
						/>
						<path
							className="cls-18"
							d="M282.66 165.41c-.16-.07 9.56 4.56 10.99 5.19 1.77.78 5.14-1.77 5.6-.58.46 1.18-1.73 1.37-2.94 2.04-1.21.67-.37 1.72.5 2.21 2.05 1.16 5.51 3.15 5.38 3.08-.13-.07-5.54.99-7.74-.4-2.2-1.39-2.93-3.81-4.95-3.75-2.02.06-11.2-2.21-11.87-2.82-.67-.61 1.52-4.72 5.01-4.96z"
							id="path891"
						/>
						<path
							d="M283.5 165.82c-.49-.36-1.8-1.5-2.52-1.31-.42.11-2.57 1.46-3.46 3.07-.88 1.62-.52 3.25-.52 3.25.24-.1 2.46.78 2.46.78.49-.36.27-2.44 1.52-3.76 1.25-1.33 2.8-1.82 2.52-2.03z"
							id="path893"
							style={{
								fill: '#f9b345',
							}}
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
)

export default WalkwayResultImage
